<template>
  <div v-bind:data-kt-indicator="isLoading ? 'on' : 'off'">
    <span class="indicator-progress">
      Aguarde, carregando...
      <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
    </span>
  </div>
  <div
    v-if="this.errosGerais.Message"
    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
  >
    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
      <inline-svg src="media/icons/duotune/general/gen044.svg" />
    </span>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-bold">
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
        <div class="fs-6 text-gray-600">
          {{ this.errosGerais.Message }}
        </div>
      </div>
    </div>
  </div>
  <div
    v-if="this.errosValidacaoGeral.length && !this.isLoading"
    class="notice d-flex bg-light-danger rounded border-danger border border-dashed mb-9 p-6"
  >
    <span class="svg-icon svg-icon-2tx svg-icon-danger me-4">
      <inline-svg src="media/icons/duotune/general/gen044.svg" />
    </span>
    <div class="d-flex flex-stack flex-grow-1">
      <div class="fw-bold">
        <h4 class="text-gray-800 fw-bolder">Aviso</h4>
        <div class="fs-6 text-gray-600">
          <ul>
            <li v-for="value in this.errosValidacaoGeral" :key="value">
              {{ value }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <div
    id="editar_produto"
    v-if="!isLoading"
    class="d-flex flex-column flex-xl-row"
  >
    <div class="d-flex flex-column flex-row-fluid gap-6 mb-7 gap-lg-10">
      <div class="card">
        <div class="card-body pt-8 pb-0">
          <div
            class="d-flex justify-content-between align-items-start flex-wrap mb-2"
          >
            <div class="d-flex flex-column mb-4">
              <h3 class="card-title">
                <img
                  src="media/icons/duotune/ecommerce/ecm009.svg"
                  class="me-2"
                />Cadastro de produtos
              </h3>
              <div class="d-flex text-muted mb-2 fs-7 align-items-center">
                Edição
                <span
                  v-if="this.produto && this.produto.id > 0"
                  class="badge badge-light-danger ms-2 me-2"
                >
                  Código : {{ this.produto.codigo }}</span
                >
                <span v-else class="badge badge-light-danger ms-2 me-2">
                  Novo cadastro</span
                >
              </div>
            </div>
            <div class="d-flex justify-content-end flex-wrap mb-2">
              <button
                v-if="this.modal === true"
                class="btn btn-danger svg-icon-white me-2 mb-2"
                data-bs-dismiss="modal"
                @click="$emit('cancelarProduto', false)"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr015.svg"
                    class="me-2"
                  />Cancelar
                </span>
              </button>
              <router-link
                v-else
                to="/cadastros/produtos/consultar"
                class="btn btn-danger svg-icon-white me-2 mb-2"
              >
                <span class="svg-icon svg-icon-1">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr015.svg"
                    class="me-2"
                  />Cancelar
                </span>
              </router-link>
              <button
                class="btn btn-success svg-icon-white mb-2"
                type="submit"
                v-bind:data-kt-indicator="loadingConfirmar ? 'on' : 'off'"
                @click.prevent="confirmar()"
              >
                <span class="indicator-progress">
                  <span
                    class="spinner-border spinner-border-sm align-middle ms-1"
                  ></span>
                  Aguarde...
                </span>
                <span class="svg-icon svg-icon-1" v-if="!loadingConfirmar">
                  <inline-svg
                    src="media/icons/duotune/arrows/arr016.svg"
                    class="me-2"
                  />Confirmar
                </span>
              </button>
            </div>
          </div>
          <div class="separator"></div>
          <div class="d-flex overflow-auto h-55px">
            <ul
              class="nav nav-stretch nav-line-tabs nav-line-tabs-2x border-transparent fs-5 fw-bold flex-nowrap"
            >
              <li class="nav-item">
                <a
                  ref="tabPrincipal"
                  class="nav-link text-active-primary pb-4 active"
                  data-bs-toggle="tab"
                  href="#kt_produto_add_produto_principal"
                  >Principal</a
                >
              </li>
              <li class="nav-item">
                <a
                  ref="tabTributacao"
                  class="nav-link text-active-primary pb-4"
                  data-bs-toggle="tab"
                  href="#kt_produto_add_produto_tributacao"
                  >Tributação</a
                >
              </li>
              <li class="nav-item">
                <a
                  ref="tabAdicionais"
                  class="nav-link text-active-primary pb-4"
                  data-bs-toggle="tab"
                  href="#kt_produto_add_produto_adicionais"
                  >Adicionais</a
                >
              </li>
              <li class="nav-item">
                <a
                  ref="tabPromocao"
                  class="nav-link text-active-primary pb-4"
                  data-bs-toggle="tab"
                  href="#kt_produto_add_produto_promocao"
                  >Promoção</a
                >
              </li>
              <li v-if="this.consultarEstoque" class="nav-item">
                <a
                  ref="tabInventario"
                  class="nav-link text-active-primary pb-4"
                  data-bs-toggle="tab"
                  href="#kt_produto_add_produto_inventario"
                  >Inventário</a
                >
              </li>
              <li class="nav-item" v-if="this.user.User.Emitente.ramo === '2'">
                <a
                  ref="tabRestaurante"
                  class="nav-link text-active-primary pb-4"
                  data-bs-toggle="tab"
                  href="#kt_produto_add_produto_restaurante"
                  >Restaurante</a
                >
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="tab-content">
        <div
          class="tab-pane fade show active"
          id="kt_produto_add_produto_principal"
          role="tab-panel"
        >
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">Dados dos Produtos</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-4 col-md-3 col-lg-3 col-xl-3 col-xxl-2 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Código</label>
                      <input
                        id="txtCodigo"
                        type="text"
                        class="form-control mb-2"
                        v-model="this.produto.codigo"
                        disabled
                      />
                    </div>
                  </div>
                  <div
                    class="col-sm-8 col-md-6 col-lg-5 col-xl-5 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Código de barras</label>
                      <input
                        id="txtBarras"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Código de barras"
                        v-model="produto.ean"
                        maxlength="14"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ean"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-3 col-lg-4 col-xl-4 col-xxl-2 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Padrão</label>
                      <select
                        class="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        v-model="this.produto.padrao_barras"
                      >
                        <option value="EAN13" selected="selected">EAN13</option>
                        <option value="EAN8">EAN8</option>
                        <option value="Peso">Peso</option>
                        <option value="Balan">Balan</option>
                        <option value="Outro">Outro</option>
                        <option value="GTIN">GTIN</option>
                        <option value="SEM GTIN">SEM GTIN</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["padrao_barras"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-3 col-lg-3 col-xl-4 col-xxl-1 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Und V.</label>
                      <input
                        id="txtUnidadeVenda"
                        type="text"
                        class="form-control mb-2"
                        maxlength="3"
                        :value="
                          (this.produto.und = this.produto.und
                            ? this.produto.und.toUpperCase()
                            : '')
                        "
                        @input="
                          this.produto.und = $event.target.value.toUpperCase()
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["und"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-3 col-lg-3 col-xl-4 col-xxl-1 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Und C.</label>
                      <input
                        id="txtUnidadeCompra"
                        type="text"
                        class="form-control mb-2"
                        maxlength="3"
                        :value="
                          (this.produto.und_c = this.produto.und_c
                            ? this.produto.und_c.toUpperCase()
                            : '')
                        "
                        @input="
                          this.produto.und_c = $event.target.value.toUpperCase()
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["und_c"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Fator</label>
                      <input
                        id="txtFator"
                        type="text"
                        class="form-control mb-2 position-absolute w-175px w-sm-200px w-md-200px w-lg-200px w-xl-200px w-xxl-200px"
                        placeholder="Selecione uma opção"
                        v-model="this.produto.fator"
                      />
                      <select
                        class="form-select mb-2 w-225px w-sm-250px w-md-250px w-lg-250px w-xl-250px w-xxl-250px"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        v-model="this.produto.fator"
                      >
                        <option value="NULO" selected="selected">NULO</option>
                        <option value="*1">*1</option>
                        <option value="*10">*10</option>
                        <option value="*100">*100</option>
                        <option value="*1000">*1000</option>
                        <option value="/1">/1</option>
                        <option value="/10">/10</option>
                        <option value="/100">/100</option>
                        <option value="/1000">/1000</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["fator"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-8 col-xxl-6 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">Nome do produto</label>
                      <input
                        id="txtNome"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Nome do produto"
                        :value="
                          (this.produto.nome = this.produto.nome
                            ? this.produto.nome.toUpperCase()
                            : '')
                        "
                        @input="
                          this.produto.nome = $event.target.value.toUpperCase()
                        "
                        maxlength="120"
                      />
                      <div class="row">
                        <div class="col-6 pe-0">
                          <div
                            class="fv-plugins-message-container invalid-feedback m-0"
                          >
                            {{ errosValidacao["nome"] }}
                          </div>
                        </div>
                        <div class="col-6 ps-2">
                          <div class="text-end text-muted fs-7">
                            {{
                              produto.nome !== null ? produto.nome.length : 0
                            }}/120 caracteres
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">NCM</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtNCM"
                          type="text"
                          class="form-control"
                          v-model="this.produto.ncm"
                          v-mask="'########'"
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalIbpts(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ncm"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-5 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <div class="d-flex justify-content-between">
                        <label class="form-label me-4">Tipo</label>
                        <div class="card-toolbar">
                          <button
                            type="button"
                            @click="modalTiposEstoque(true)"
                            class="btn btn-sm btn-secondary px-2 py-0 m-0"
                          >
                            <span class="svg-icon svg-icon-1 m-0">
                              <inline-svg
                                src="media/icons/duotune/general/gen041.svg"
                            /></span>
                          </button>
                        </div>
                      </div>
                      <select
                        class="form-select mb-0"
                        data-placeholder="Selecione uma opção"
                        v-model="produto.tipo"
                      >
                        <template v-for="tipo in this.tipos" :key="tipo">
                          <option
                            :value="tipo.descricao"
                            v-bind:selected="[
                              tipo.descricao === produto.tipo ? 'selected' : '',
                            ]"
                          >
                            {{ tipo.descricao }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["tipo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-5 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Características</label>
                      <input
                        id="txtCaracteristicas"
                        type="text"
                        class="form-control mb-2"
                        v-model="produto.caracteristica"
                        maxlength="300"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["caracteristica"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Local Armazenado</label>
                      <input
                        id="txtLocalArmazenado"
                        type="text"
                        class="form-control mb-2"
                        v-model="produto.local_armazenado"
                        maxlength="50"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["local_armazenado"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Tamanho</label>
                      <input
                        id="txtTamanho"
                        type="text"
                        class="form-control mb-2"
                        v-model="produto.tamanho"
                        maxlength="30"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["tamanho"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Grupo</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtGrupo"
                          type="text"
                          class="form-control"
                          :value="
                            this.produto.Grupo ? this.produto.Grupo.codigo : ''
                          "
                          readonly
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalGrupos(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_grupo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Sub Grupo</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtSubGrupo"
                          type="text"
                          class="form-control"
                          v-model="this.produto.id_subgrupo"
                          readonly
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.consultaSubGrupos()"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_subgrupo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Categoria</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtCategoria"
                          type="text"
                          class="form-control"
                          v-model="this.produto.id_categoria"
                          readonly
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalCategoriasEstoque(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["id_categoria"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <div class="d-flex justify-content-between">
                        <label class="form-label me-4">Situação</label>
                        <div class="card-toolbar">
                          <div
                            class="rounded-circle w-15px h-15px"
                            :class="[
                              produto.ativo === '1'
                                ? 'bg-success'
                                : 'bg-danger',
                            ]"
                            id="kt_ecommerce_add_product_status"
                          ></div>
                        </div>
                      </div>
                      <select
                        class="form-select mb-2"
                        data-placeholder="Selecione uma opção"
                        id="kt_ecommerce_add_product_status_select"
                        v-model="produto.ativo"
                      >
                        <option value="1">Ativo</option>
                        <option value="0">Indisponível</option>
                      </select>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Descrição</label>
                      <textarea
                        id="txtDescricao"
                        class="form-control mb-2"
                        placeholder="Descreva o seu produto"
                        maxlength="300"
                        style="height: 100px"
                        v-model="produto.descricao"
                      />
                      <div class="row">
                        <div class="col-6 pe-0">
                          <div
                            class="fv-plugins-message-container invalid-feedback m-0"
                          >
                            {{ errosValidacao["descricao"] }}
                          </div>
                        </div>
                        <div class="col-6 ps-2">
                          <div class="text-end text-muted fs-7">
                            {{
                              produto.descricao !== null
                                ? produto.descricao.length
                                : 0
                            }}/300 caracteres
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Mínimo</label>
                      <CurrencyInput
                        id="txtMinimo"
                        class="form-control mb-2"
                        v-model="produto.qtd_minima"
                        style="text-align: right"
                        :options="options"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["qtd_minima"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Máximo</label>
                      <CurrencyInput
                        id="txtMaximo"
                        class="form-control mb-2"
                        v-model="produto.qtd_maxima"
                        style="text-align: right"
                        :options="options"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["qtd_maxima"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Peso Bruto</label>
                      <CurrencyInput
                        id="txtPesoBruto"
                        class="form-control mb-2"
                        v-model="produto.peso"
                        style="text-align: right"
                        :options="options"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["peso"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Peso Líquido</label>
                      <CurrencyInput
                        id="txtPesoLiquido"
                        class="form-control mb-2"
                        v-model="produto.peso_liquido"
                        style="text-align: right"
                        :options="options"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["peso_liquido"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">Valores</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">Preço de Custo</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="Preço de Custo"
                        style="text-align: right"
                        v-model="produto.preco_custo"
                        @input="
                          this.produto.ProdutoSimulador.preco_custo =
                            produto.preco_custo
                        "
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_custo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "b05eb8ed-b413-4a7f-8bba-efdbf3182d6c"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2 text-danger"
                        style="text-align: right"
                        v-model="produto.preco"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "5a453ca4-9f76-44c3-b603-11ea1ab3e4fd"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.preco_revenda"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_revenda"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "f03cc6d6-99dd-4d15-abc9-f803fc39b26f"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.preco_distribuidora"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_distribuidora"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "53a025c0-9c12-4843-85dd-2c32af180720"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.preco_venda_prazo"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_venda_prazo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "808c0401-b5f5-4fe6-9ab5-69e76cfc842b"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.preco_prazo_revenda"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_prazo_revenda"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "3e21b497-8ee5-497b-b268-0194a4562473"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.prazo_distribuidora"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["prazo_distribuidora"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "06ac70d2-a02d-416c-b031-f9ca73d51e7c"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.outro_preco_venda"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["outro_preco_venda"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "09acccc0-eb6e-49b2-9990-61274f5fb22e"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.preco_ultima_compra"
                        @input="
                          this.produto.ProdutoSimulador.preco_ultima_compra =
                            produto.preco_ultima_compra
                        "
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_ultima_compra"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">{{
                        this.retornaLabelDescricao(
                          "59f5abd9-0622-41ef-b6d5-ab47b9a10a60"
                        )
                      }}</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        style="text-align: right"
                        v-model="produto.preco_custo_medio"
                        :options="optionsPreco"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_custo_medio"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">Qtd Parcelas</label>
                      <input
                        id="txtQtdParcelas"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Qtd Parcelas"
                        v-model="produto.qtd_parcelas"
                        v-mask="'###'"
                        @input="calculaTotalDividido()"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["qtd_parcelas"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="this.totalDividido > 0"
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Total Dividido</label>
                      <CurrencyInput
                        class="form-control form-control-transparent text-danger mb-2"
                        placeholder="0,00"
                        style="text-align: left"
                        v-model="this.totalDividido"
                        :options="options"
                        readonly
                      ></CurrencyInput>
                    </div>
                  </div>
                </div>
                <el-divider content-position="left"
                  ><h4 class="text-primary">
                    Definição de Valores
                  </h4></el-divider
                >
                <div class="row">
                  <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2">
                    <h4 class="text-primary ms-4">Base Cálculo</h4>
                    <div
                      class="card border border-rounded border-gray-300 mb-4 mt-4 p-6"
                    >
                      <div class="row">
                        <div class="col-12 mb-4">
                          <div class="fv-row">
                            <label class="form-label">Preço de Custo</label>
                            <div class="d-flex mb-2">
                              <div class="col-10">
                                <CurrencyInput
                                  class="form-control"
                                  style="text-align: right"
                                  v-model="produto.ProdutoSimulador.preco_custo"
                                  :options="optionsPreco"
                                  @keydown.stop.prevent.enter="
                                    nextFocus(`txtUltimaCompra`)
                                  "
                                ></CurrencyInput>
                              </div>
                              <div
                                class="col-2 form-check form-check-custom form-check-sm ms-2"
                              >
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="rbBaseCalculo"
                                  id="rbPrecoCusto"
                                  :checked="
                                    this.produto.ProdutoSimulador
                                      .utiliza_custo === '1'
                                  "
                                  @change="
                                    this.produto.ProdutoSimulador.utiliza_custo =
                                      '1'
                                  "
                                />
                              </div>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaopreco_custo"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mb-4">
                          <div class="fv-row">
                            <label class="form-label">Última Compra</label>
                            <div class="d-flex mb-2">
                              <div class="col-10">
                                <CurrencyInput
                                  id="txtUltimaCompra"
                                  class="form-control"
                                  style="text-align: right"
                                  v-model="
                                    produto.ProdutoSimulador.preco_ultima_compra
                                  "
                                  :options="optionsPreco"
                                  @keydown.stop.prevent.enter="
                                    nextFocus(
                                      enableCamposLucro
                                        ? `txtIPICompra`
                                        : `txtComissao`
                                    )
                                  "
                                ></CurrencyInput>
                              </div>
                              <div
                                class="col-2 form-check form-check-custom form-check-sm ms-2"
                              >
                                <input
                                  class="form-check-input"
                                  type="radio"
                                  name="rbBaseCalculo"
                                  id="rbUltimaCompra"
                                  :checked="
                                    this.produto.ProdutoSimulador
                                      .utiliza_custo === '0'
                                  "
                                  @change="
                                    this.produto.ProdutoSimulador.utiliza_custo =
                                      '0'
                                  "
                                />
                              </div>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao[
                                  "ProdutoTributacaopreco_ultima_compra"
                                ]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3">
                    <h4 class="text-primary ms-4">Valores Calculados</h4>
                    <div
                      class="card border border-rounded border-gray-300 mb-4 mt-4 p-6"
                    >
                      <div class="row">
                        <div class="col-12 mb-4">
                          <div class="fv-row">
                            <label class="form-label">Preço de Venda</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtPrecoVenda"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Pressione enter para recalcular"
                                class="form-control text-danger"
                                style="text-align: right"
                                v-model="
                                  this.produto.ProdutoSimulador.preco_venda
                                "
                                @keydown.stop.prevent.enter="
                                  this.recalcularLucro(
                                    $event.target.value,
                                    true
                                  ),
                                    nextFocus(`txtPrecoRevenda`)
                                "
                                :options="options"
                              ></CurrencyInput>
                              <button
                                id="btnPrecoVenda"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Definir valor calculado ao preço de venda"
                                type="button"
                                class="input-group-text"
                                @click="
                                  this.produto.preco =
                                    produto.ProdutoSimulador.preco_venda
                                "
                              >
                                <span class="svg-icon svg-icon-2">
                                  <inline-svg
                                    src="media/icons/duotune/arrows/arr081.svg"
                                  />
                                </span>
                              </button>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaopreco_venda"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mb-4">
                          <div class="fv-row">
                            <label class="form-label">Preço Revenda</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtPrecoRevenda"
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Pressione enter para recalcular"
                                class="form-control text-success"
                                style="text-align: right"
                                v-model="
                                  this.produto.ProdutoSimulador.preco_revenda
                                "
                                @keydown.stop.prevent.enter="
                                  this.recalcularLucro(
                                    $event.target.value,
                                    false
                                  ),
                                    nextFocus(`btnPrecoVenda`)
                                "
                                :options="options"
                              ></CurrencyInput>
                              <button
                                data-bs-toggle="tooltip"
                                data-bs-placement="top"
                                title="Definir valor calculado ao preço de revenda"
                                type="button"
                                class="input-group-text"
                                @click="
                                  this.produto.preco_revenda =
                                    produto.ProdutoSimulador.preco_revenda
                                "
                              >
                                <span class="svg-icon svg-icon-2">
                                  <inline-svg
                                    src="media/icons/duotune/arrows/arr081.svg"
                                  />
                                </span>
                              </button>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaopreco_revenda"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div class="col-12 mb-4">
                          <div class="fv-row">
                            <label class="form-label">Preço com desconto</label>
                            <CurrencyInput
                              data-bs-toggle="tooltip"
                              data-bs-placement="top"
                              title="Pressione enter para recalcular"
                              class="form-control text-primary mb-2"
                              style="text-align: right"
                              v-model="
                                this.produto.ProdutoSimulador
                                  .preco_venda_desconto
                              "
                              @keydown.stop.prevent.enter="
                                this.recalcularLucroDesconto(
                                  $event.target.value
                                )
                              "
                              :options="options"
                              :disabled="!enableCamposLucro"
                            ></CurrencyInput>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao[
                                  "ProdutoTributacaopreco_venda_desconto"
                                ]
                              }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-7"
                  >
                    <h4 class="text-primary ms-4">% Aplicados</h4>
                    <div
                      class="card border border-rounded border-gray-300 mb-4 mt-4 p-6"
                    >
                      <div class="row">
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">IPI Compra</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtIPICompra"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.ipi_compra"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtIPIVenda`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaoipi_compra"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">IPI Venda</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtIPIVenda"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.ipi_venda"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtComissao`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacao["ProdutoTributacaoipi_venda"] }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Comissão</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtComissao"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.comissao"
                                :options="options"
                                @keydown.stop.prevent.enter="
                                  nextFocus(
                                    enableCamposLucro
                                      ? `txtOutros`
                                      : `txtLucroVenda`
                                  )
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacao["ProdutoTributacaocomissao"] }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Outros</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtOutros"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.outros"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtFrete`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacao["ProdutoTributacaooutros"] }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Frete</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtFrete"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.frete"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtOperacional`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacao["ProdutoTributacaofrete"] }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Operacional</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtOperacional"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.operacional"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtLucroVenda`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaooperacional"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Lucro Venda</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtLucroVenda"
                                class="form-control text-danger"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.lucro_venda"
                                :options="options"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtLucroRevenda`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaolucro_venda"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Lucro Revenda</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtLucroRevenda"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.lucro_revenda"
                                :options="options"
                                @keydown.stop.prevent.enter="
                                  nextFocus(
                                    enableCamposLucro
                                      ? `txtICMVenda`
                                      : `txtPrecoVenda`
                                  )
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaolucro_revenda"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">ICM Venda</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtICMVenda"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.icm_venda"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtICMCompra`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacao["ProdutoTributacaoicm_venda"] }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">ICM Compra</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtICMCompra"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.icm_compra"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtMaoObra`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaoicm_compra"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Mão de Obra</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtMaoObra"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.mao_de_obra"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtDesconto`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{
                                errosValidacao["ProdutoTributacaomao_de_obra"]
                              }}
                            </div>
                          </div>
                        </div>
                        <div
                          class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-3 mb-4"
                        >
                          <div class="fv-row">
                            <label class="form-label">Desconto</label>
                            <div class="input-group mb-2">
                              <CurrencyInput
                                id="txtDesconto"
                                class="form-control"
                                style="text-align: right"
                                v-model="produto.ProdutoSimulador.desconto"
                                :options="options"
                                :disabled="!enableCamposLucro"
                                @keydown.stop.prevent.enter="
                                  nextFocus(`txtPrecoVenda`)
                                "
                              ></CurrencyInput>
                              <span class="input-group-text">%</span>
                            </div>
                            <div
                              class="fv-plugins-message-container invalid-feedback"
                            >
                              {{ errosValidacao["ProdutoTributacaodesconto"] }}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="kt_produto_add_produto_tributacao"
          role="tab-panel"
        >
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">ICMs/IPI</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-7 col-md-7 col-lg-7 col-xl-7 col-xxl-5 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Tipo de Tributação</label>
                      <select
                        class="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        @change="
                          this.atualizaTipoTributacao($event.target.value)
                        "
                        v-model="this.produto.ProdutoTributacao.tipo_tributacao"
                      >
                        <option value="Normal" selected="selected">
                          Normal
                        </option>
                        <option value="Substituição Tributária">
                          Substituição Tributária
                        </option>
                        <option value="Isenção">Isenção</option>
                        <option value="Não Incidência">Não Incidência</option>
                        <option value="ISS">ISS</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaotipo_tributacao"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="this.user.User.Emitente.crt != 1"
                    class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">S.T</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtST"
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoTributacao.st"
                          maxlength="3"
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalST(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaost"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="this.user.User.Emitente.crt === 1"
                    class="col-sm-5 col-md-5 col-lg-5 col-xl-5 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">CSOSN</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtCSOSN"
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoTributacao.csosn"
                          maxlength="4"
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalCSOSN(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocsosn"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-4 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Clas. Fiscal</label>
                      <input
                        id="txtClasFiscal"
                        type="text"
                        class="form-control mb-2"
                        v-model="
                          this.produto.ProdutoTributacao.classificacao_fiscal
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao[
                            "ProdutoTributacaoclassificacao_fiscal"
                          ]
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% Imposto</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% Imposto"
                        style="text-align: right"
                        v-model="
                          this.produto.ProdutoTributacao.por_imposto_prod
                        "
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["ProdutoTributacaopor_imposto_prod"]
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Aliq. ICMs %</label>
                      <select
                        class="form-select mb-0"
                        data-placeholder="Selecione uma opção"
                        v-model="this.produto.ProdutoTributacao.icms"
                      >
                        <template
                          v-for="aliquota in this.aliquotas"
                          :key="aliquota"
                        >
                          <option
                            :value="aliquota.aliquota"
                            v-bind:selected="[
                              aliquota.aliquota ===
                              this.produto.ProdutoTributacao.icms
                                ? 'selected'
                                : '',
                            ]"
                          >
                            {{ aliquota.aliquota }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaoicms"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% MVA</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% MVA"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.mva"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaomva"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% Redução</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% Redução"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.reducao"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaoreducao"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% IPI</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% IPI"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.ipi"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaoipi"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">C.F.O.P</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtCFOP"
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoTributacao.cfop"
                          readonly
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalCfops(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocfop"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">Aliq. Interna</label>
                      <select
                        class="form-select mb-0"
                        data-placeholder="Selecione uma opção"
                        v-model="this.produto.ProdutoTributacao.aliqi"
                      >
                        <template
                          v-for="aliquota in this.aliquotas"
                          :key="aliquota"
                        >
                          <option
                            :value="aliquota.aliquota"
                            v-bind:selected="[
                              aliquota.aliquota ===
                              this.produto.ProdutoTributacao.aliqi
                                ? 'selected'
                                : '',
                            ]"
                          >
                            {{ aliquota.aliquota }}
                          </option>
                        </template>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaoaliqi"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">CEST</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtCEST"
                          type="text"
                          class="form-control"
                          v-mask="'#######'"
                          v-model="this.produto.ProdutoTributacao.cest"
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalCests(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocest"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-4 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Tabela de Estados</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtTabelaEstados"
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoTributacao.id_estoque_st"
                          readonly
                        />
                        <span
                          class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                          @click="limparTabelaEstados()"
                        >
                          <inline-svg
                            src="media/icons/duotune/arrows/arr061.svg"
                          />
                        </span>
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalTabelaEstados(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaoid_estoque_st"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-5 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">CST IPI</label>
                      <select
                        class="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        v-model="this.produto.ProdutoTributacao.cst_ipi"
                      >
                        <option value="00" selected="selected">
                          00 - Entrada com recuperação de crédito
                        </option>
                        <option value="01">
                          01 - Entrada tributada com alíquota zero
                        </option>
                        <option value="02">02 - Entrada isenta</option>
                        <option value="03">03 - Entrada não-tributada</option>
                        <option value="04">04 - Entrada imune</option>
                        <option value="05">05 - Entrada com suspensão</option>
                        <option value="49">49 - Outras entradas</option>
                        <option value="50">50 - Saída tributada</option>
                        <option value="51">
                          51 - Saída tributada com alíquota zero
                        </option>
                        <option value="52">52 - Saída isenta</option>
                        <option value="53">53 - Saída não-tributada</option>
                        <option value="54">54 - Saída imune</option>
                        <option value="55">55 - Saída com suspensão</option>
                        <option value="99">99 - Outras saídas</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocst_ipi"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Cód. Serviço</label>
                      <div class="input-group mb-2">
                        <input
                          id="txtCodServico"
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoTributacao.cod_servico"
                          readonly
                        />
                        <button
                          type="button"
                          class="input-group-text"
                          @click="this.modalServicosCnaeDets(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocod_servico"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <el-divider content-position="left"
                  ><h4 class="text-primary">
                    PIS - Operações de Saída
                  </h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-9 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required"
                        >Código da Situação Tributária ao PIS</label
                      >
                      <div class="input-group mb-2">
                        <select
                          class="form-select"
                          data-control="select2"
                          data-hide-search="true"
                          data-placeholder="Selecione uma opção"
                          v-model="this.produto.ProdutoTributacao.pis_st"
                        >
                          <option value="01" selected="selected">
                            01 - Operação Tributável com Alíquota Básica
                          </option>
                          <option value="02">
                            02 - Operação Tributável com Alíquota Diferenciada
                          </option>
                          <option value="03">
                            03 - Operação Tributável com Alíquota por Unidade de
                            Medida de Produto
                          </option>
                          <option value="04">
                            04 - Operação Tributável Monofásica - Revenda a
                            Alíquota Zero
                          </option>
                          <option value="05">
                            05 - Operação Tributável por Substituição Tributária
                          </option>
                          <option value="06">
                            06 - Operação Tributável a Alíquota Zero
                          </option>
                          <option value="07">
                            07 - Operação Isenta da Contribuição
                          </option>
                          <option value="08">
                            08 - Operação sem Incidência da Contribuição
                          </option>
                          <option value="09">
                            09 - Operação com Suspensão da Contribuição
                          </option>
                          <option value="49">
                            49 - Outras Operações de Saída
                          </option>
                          <option value="99">99 - Outras Operações</option>
                        </select>
                        <button
                          type="button"
                          class="input-group-text"
                          @click="
                            this.exibirCamposBasePIS = !this.exibirCamposBasePIS
                          "
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              v-if="this.exibirCamposBasePIS"
                              src="media/icons/duotune/arrows/arr081.svg"
                            />
                            <inline-svg
                              v-else
                              src="media/icons/duotune/arrows/arr082.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaopis_st"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% PIS</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% PIS"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.pis_aliq"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaopis_aliq"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="this.exibirCamposBasePIS" class="row">
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% Base PIS</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% Base PIS"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.pis_base"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaopis_base"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% PIS Subs.</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% PIS Subs."
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.pis_subs"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaopis_subs"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required"
                        >% Base Cálculo PIS Subs.</label
                      >
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% Base Cálculo PIS Subs."
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.pis_subs_base"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaopis_subs_base"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <el-divider content-position="left"
                  ><h4 class="text-primary">
                    COFINS - Operações de Saída
                  </h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-9 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required"
                        >Código da Situação Tributária ao COFINS</label
                      >
                      <div class="input-group mb-2">
                        <select
                          class="form-select"
                          data-control="select2"
                          data-hide-search="true"
                          data-placeholder="Selecione uma opção"
                          v-model="this.produto.ProdutoTributacao.cofins_st"
                        >
                          <option value="01" selected="selected">
                            01 - Operação Tributável com Alíquota Básica
                          </option>
                          <option value="02">
                            02 - Operação Tributável com Alíquota Diferenciada
                          </option>
                          <option value="03">
                            03 - Operação Tributável com Alíquota por Unidade de
                            Medida de Produto
                          </option>
                          <option value="04">
                            04 - Operação Tributável Monofásica - Revenda a
                            Alíquota Zero
                          </option>
                          <option value="05">
                            05 - Operação Tributável por Substituição Tributária
                          </option>
                          <option value="06">
                            06 - Operação Tributável a Alíquota Zero
                          </option>
                          <option value="07">
                            07 - Operação Isenta da Contribuição
                          </option>
                          <option value="08">
                            08 - Operação sem Incidência da Contribuição
                          </option>
                          <option value="09">
                            09 - Operação com Suspensão da Contribuição
                          </option>
                          <option value="49">
                            49 - Outras Operações de Saída
                          </option>
                          <option value="99">99 - Outras Operações</option>
                        </select>
                        <button
                          type="button"
                          class="input-group-text"
                          @click="
                            this.exibirCamposBaseCOFINS =
                              !this.exibirCamposBaseCOFINS
                          "
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              v-if="this.exibirCamposBaseCOFINS"
                              src="media/icons/duotune/arrows/arr081.svg"
                            />
                            <inline-svg
                              v-else
                              src="media/icons/duotune/arrows/arr082.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocofins_st"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% COFINS</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% COFINS"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.cofins_aliq"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocofins_aliq"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="this.exibirCamposBaseCOFINS" class="row">
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% Base COFINS</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% Base COFINS"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.cofins_base"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocofins_base"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% COFINS Subs.</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% COFINS Subs."
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.cofins_subs"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocofins_subs"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required"
                        >% Base Cálculo COFINS Subs.</label
                      >
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="% Base Cálculo COFINS Subs."
                        style="text-align: right"
                        v-model="
                          this.produto.ProdutoTributacao.cofins_subs_base
                        "
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao["ProdutoTributacaocofins_subs_base"]
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-5 mb-4"
                  >
                    <h4 class="text-primary ms-4 mt-4">Sped</h4>
                    <div
                      class="card border border-rounded border-gray-300 mb-4 mt-7 p-6"
                    >
                      <div class="col-12 mb-4">
                        <div class="fv-row">
                          <label class="form-label required"
                            >Gênero do produto</label
                          >
                          <div class="input-group mb-2">
                            <input
                              id="txtCodGenero"
                              type="text"
                              class="form-control"
                              v-model="
                                this.produto.ProdutoTributacao.cod_genero
                              "
                              readonly
                            />
                            <button
                              type="button"
                              class="input-group-text"
                              @click="this.modalGeneroSpeds(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["ProdutoTributacaocod_genero"] }}
                          </div>
                        </div>
                      </div>
                      <div class="col-12 mb-4">
                        <div class="fv-row">
                          <label class="form-label required"
                            >Tipo do produto</label
                          >
                          <select
                            class="form-select mb-2"
                            data-control="select2"
                            data-hide-search="true"
                            data-placeholder="Selecione uma opção"
                            v-model="
                              this.produto.ProdutoTributacao.cod_tipo_sped
                            "
                          >
                            <option value="00" selected="selected">
                              00 - Mercadoria para revenda
                            </option>
                            <option value="01">01 - Matéria-Prima</option>
                            <option value="02">02 - Embalagem</option>
                            <option value="03">03 - Produto em Processo</option>
                            <option value="04">04 - Produto Acabado</option>
                            <option value="05">05 - Subproduto</option>
                            <option value="06">
                              06 - Produto Intermediário
                            </option>
                            <option value="07">
                              07 - Material de Uso e Consumo
                            </option>
                            <option value="08">08 - Ativo Imobilizado</option>
                            <option value="09">09 - Serviços</option>
                            <option value="10">10 - Outros Insumos</option>
                            <option value="99">99 - Outras</option>
                          </select>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              errosValidacao["ProdutoTributacaocod_tipo_sped"]
                            }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-7 mb-4"
                  >
                    <el-divider content-position="left"
                      ><h4 class="text-primary">Outras</h4></el-divider
                    >
                    <div class="col-12 mb-4">
                      <div class="fv-row">
                        <label class="form-label">Fórmula BC ICMS ST</label>
                        <textarea
                          id="txtFormulaBcIcmsST"
                          class="form-control mb-2"
                          maxlength="300"
                          style="height: 80px"
                          v-model="
                            this.produto.ProdutoTributacao.formula_base_st
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["ProdutoTributacaoformula_base_st"]
                          }}
                        </div>
                      </div>
                    </div>
                    <div class="col-12 mb-4">
                      <div class="fv-row">
                        <label class="form-label">Fórmula Valor ICMS ST</label>
                        <textarea
                          id="txtFormulaValorIcmsST"
                          class="form-control mb-2"
                          maxlength="300"
                          style="height: 80px"
                          v-model="
                            this.produto.ProdutoTributacao.formula_icms_st
                          "
                        />
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao["ProdutoTributacaoformula_icms_st"]
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <el-divider content-position="left"
                  ><h4 class="text-primary">Combustível</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-8 col-md-8 col-lg-8 col-xl-8 col-xxl-4 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Código ANP</label>
                      <input
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Código ANP - É o código dos produtos combustíveis e lubrificante
 na Agência Nacional do Petróleo (ANP) e que possui 9 dígitos. "
                        id="txtCodigoANP"
                        type="text"
                        class="form-control mb-2"
                        maxlength="9"
                        v-model="this.produto.ProdutoTributacao.cod_anp"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaocod_anp"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% GNn</label>
                      <CurrencyInput
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Percentual de Gás Natural Nacional – GLGNn para o produto GLP"
                        class="form-control mb-2"
                        placeholder="% GNn"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.p_gnn"
                        :options="options2"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaop_gnn"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% GLP</label>
                      <CurrencyInput
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Percentual do GLP derivado do petróleo no produto GLP"
                        class="form-control mb-2"
                        placeholder="% GLP"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.p_glp"
                        :options="options2"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaop_glp"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">% GNI</label>
                      <CurrencyInput
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Percentual de Gás Natural Importado – GLGNi para o produto GLP"
                        class="form-control mb-2"
                        placeholder="% GNI"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.p_gni"
                        :options="options2"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaop_gni"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-4 col-md-4 col-lg-4 col-xl-4 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label required">V. Part</label>
                      <CurrencyInput
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Valor de partida"
                        class="form-control mb-2"
                        placeholder="V. Part"
                        style="text-align: right"
                        v-model="this.produto.ProdutoTributacao.v_part"
                        :options="options"
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoTributacaov_part"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="card-footer d-flex justify-content-end">
                <div class="row">
                  <div class="col-auto">
                    <button
                      @click="modalAliquotas(true)"
                      type="button"
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="Cadastro de Alíquotas"
                      class="btn btn-light-primary svg-icon-white mb-2 min-w-150px"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg
                          src="media/icons/duotune/ecommerce/ecm003.svg"
                        />
                        Alíquota
                      </span>
                    </button>
                  </div>
                  <div class="col-auto">
                    <button
                      @click="this.modalTabelaEstados(true)"
                      type="button"
                      class="btn btn-light-primary svg-icon-white mb-2 min-w-150px"
                    >
                      <span class="svg-icon svg-icon-1">
                        <inline-svg src="media/icons/duotune/maps/map009.svg" />
                        Tabela de Estados
                      </span>
                    </button>
                  </div>
                  <div class="col-auto">
                    <button
                      @click="this.modalTributacoes(true)"
                      type="button"
                      class="btn btn-light-primary svg-icon-white mb-2 min-w-150px"
                    >
                      <b>%</b> Tributações
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="kt_produto_add_produto_restaurante"
          role="tab-panel"
        >
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">Geral</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Código PDV (SKU)</label>
                      <input
                        id="txtCodReferencia"
                        type="text"
                        class="form-control mb-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="O código PDV é o código de referência da sua aplicação"
                        placeholder="Código PDV (SKU)"
                        v-model="produto.cod_referencia"
                        maxlength="14"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["cod_referencia"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Tempo de preparo</label>
                      <input
                        id="txtTempoPreparo"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Tempo de preparo"
                        v-model="produto.tempo_preparo"
                        v-mask="'##:##:##'"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["tempo_preparo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row">
                      <label for="txtAdicional" class="form-label"
                        >Selecione um adicional</label
                      >
                      <div class="input-group mb-2">
                        <input
                          type="text"
                          id="txtAdicional"
                          class="form-control"
                          v-model="adicionalSelecionado.descricao"
                          readonly
                        />
                        <button
                          v-if="this.consultarAdicional"
                          type="button"
                          class="input-group-text"
                          @click="modalAdicionais(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div class="text-muted fs-7">
                        Selecione um adicional para o produto
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">Tamanho</h4></el-divider
                >
                <div class="row">
                  <template v-for="(qtd, index) in qtdPessoas" :key="index">
                    <div
                      class="col-sm-6 col-md-6 col-lg-6 col-xl-4 col-xxl-4 mb-4"
                      data-kt-buttons="true"
                      data-kt-buttons-target="[data-kt-button='true']"
                    >
                      <label
                        @click="produto.serve_pessoas = qtd.value"
                        class="btn btn-outline btn-outline-dashed btn-outline-default d-flex py-8 px-5"
                        v-bind:class="[
                          produto.serve_pessoas === qtd.value ? 'active' : '',
                        ]"
                        :data-bs-target="`#kt_update_serve_pessoas_${index}`"
                      >
                        <span
                          class="form-check form-check-custom form-check-solid form-check-sm"
                        >
                          <input
                            class="form-check-input"
                            type="radio"
                            name="serve_pessoas"
                            :value="qtd.value"
                            :checked="produto.serve_pessoas === qtd.value"
                            v-model="produto.serve_pessoas"
                          />
                        </span>
                        <span>
                          <h2
                            class="fs-4 fw-bolder text-gray-800 my-0 ms-5 text-start"
                          >
                            {{ qtd.title }}
                          </h2>
                        </span>
                      </label>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="kt_produto_add_produto_promocao"
          role="tab-panel"
        >
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">Promoção</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="flexSwitchChecked"
                          :checked="this.produto.promocao_ativa === '1'"
                          @change="
                            this.produto.promocao_ativa =
                              this.produto.promocao_ativa === '1' ? '0' : '1'
                          "
                        />
                        <label
                          class="form-check-label fw-bold"
                          for="flexSwitchChecked"
                          >Utiliza promoção</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-sm-7 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">Preço promoção</label>
                      <CurrencyInput
                        id="txtPrecoPromocao"
                        class="form-control mb-2"
                        placeholder="Preço promoção"
                        v-model="produto.preco_promocao"
                        style="text-align: right"
                        :options="options"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Pressione enter para recalcular o desconto"
                        @keydown.stop.prevent.enter="
                          recalcularPorcPromocao(false)
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["preco_promocao"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-5 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Desconto</label>
                      <div class="input-group mb-2">
                        <CurrencyInput
                          id="txtDescontoPromocao"
                          class="form-control text-success"
                          style="text-align: right"
                          v-model="produto.percentual_desconto"
                          :options="options"
                          @input="recalcularPorcPromocao(true)"
                        ></CurrencyInput>
                        <span class="input-group-text">%</span>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["percentual_desconto"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-5 col-lg-5 col-xl-5 col-xxl-5 mb-4"
                  >
                    <div class="fv-row">
                      <label class="required form-label">Tipo promoção</label>
                      <select
                        class="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        id="kt_ecommerce_add_product_promocao_select"
                        v-model="produto.promocao_tipo"
                      >
                        <option value="0" selected="selected">Todo dia</option>
                        <option value="1">Dia da semana</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["promocao_tipo"] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row" v-if="produto.promocao_tipo == '1'">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
                  >
                    <label for="dtpDataInicialPromocao" class="form-label"
                      >Período da promoção</label
                    >
                    <div class="row mt-4">
                      <template
                        v-for="(dia, index) in diasPromocao"
                        :key="index"
                      >
                        <div
                          class="col-sm-6 col-md-4 col-lg-4 col-xl-2 col-xxl-2 fv-row"
                        >
                          <div
                            class="form-check form-check-custom form-check-solid mb-4 me-4"
                          >
                            <input
                              class="form-check-input"
                              type="checkbox"
                              v-model="dia.selecionado"
                              :id="`#chkDiaPromocao_${index}`"
                            />
                            <label
                              class="form-check-label"
                              :for="`#chkDiaPromocao_${index}`"
                              >{{ dia.descricao }}</label
                            >
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4"
                  >
                    <div class="fv-row">
                      <label
                        for="dtpDataInicialPromocao"
                        class="required form-label"
                        >Data início promoção</label
                      >
                      <el-date-picker
                        id="dtpDataInicialPromocao"
                        v-model="produto.data_inicio_promocao"
                        type="datetime"
                        name="dtpDataInicialPromocao"
                        placeholder="Selecione uma data"
                        class="w-100"
                        format="DD/MM/YYYY HH:mm:ss"
                        size="large"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["data_inicio_promocao"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-12 col-md-6 col-lg-6 col-xl-6 col-xxl-6 mb-4"
                  >
                    <div class="fv-row">
                      <label
                        for="dtpDataFimPromocao"
                        class="required form-label"
                        >Data fim promoção</label
                      >
                      <el-date-picker
                        id="dtpDataFimPromocao"
                        v-model="produto.data_fim_promocao"
                        type="datetime"
                        name="dtpDataFimPromocao"
                        placeholder="Selecione uma data"
                        class="w-100"
                        format="DD/MM/YYYY HH:mm:ss"
                        size="large"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["data_fim_promocao"] }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="kt_produto_add_produto_adicionais"
          role="tab-panel"
        >
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary">Dados Adicionais</h4></el-divider
                >
                <div class="row">
                  <div
                    class="col-sm-12 col-md-4 col-lg-4 col-xl-4 col-xxl-4 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Tipo do Produto</label>
                      <select
                        class="form-select mb-2"
                        data-control="select2"
                        data-hide-search="true"
                        data-placeholder="Selecione uma opção"
                        v-model="this.produto.ProdutoAdicional.tipo_produto"
                      >
                        <option value="Normal" selected="selected">
                          Normal
                        </option>
                        <option value="Composição">Composição</option>
                        <option value="Consumo Próprio">Consumo Próprio</option>
                        <option value="CPV">CPV</option>
                        <option value="CMV">CMV</option>
                        <option value="CSP">CSP</option>
                      </select>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionaltipo_produto"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-7 col-md-5 col-lg-5 col-xl-5 col-xxl-5 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Lote</label>
                      <input
                        id="txtLote"
                        type="text"
                        class="form-control mb-2"
                        v-model="this.produto.ProdutoAdicional.lote"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionallote"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-5 col-md-3 col-lg-3 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Data de Validade</label>
                      <el-date-picker
                        id="dtpDataValidade"
                        v-model="produto.ProdutoAdicional.data_validade"
                        type="datetime"
                        name="dtpDataValidade"
                        placeholder="Selecione uma data"
                        class="w-100"
                        format="DD/MM/YYYY"
                        size="large"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionaldata_validade"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-2 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Conta</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoAdicional.id_conta"
                        />
                        <button
                          class="input-group-text"
                          @click="this.modalContas(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionalid_conta"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-3 col-lg-3 col-xl-3 col-xxl-2 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Custo</label>
                      <div class="input-group">
                        <input
                          type="text"
                          class="form-control"
                          v-model="this.produto.ProdutoAdicional.id_custo"
                          readonly
                        />
                        <button
                          class="input-group-text"
                          @click="this.modalCustos(true)"
                        >
                          <span class="svg-icon svg-icon-2">
                            <inline-svg
                              src="media/icons/duotune/general/gen004.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionalid_custo"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">DUN14</label>
                      <input
                        id="txtDUN14"
                        type="text"
                        class="form-control mb-2"
                        v-model="this.produto.ProdutoAdicional.dun14"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionaldun14"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">EAN13 (DUN14)</label>
                      <input
                        id="txtEAN13DUN14"
                        type="text"
                        class="form-control mb-2"
                        v-model="this.produto.ProdutoAdicional.dun14_ean13"
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao["ProdutoAdicionaldun14_ean13"] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="d-flex align-items-center col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-2 mb-4"
                  >
                    <div class="fv-row">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="idUtilizaDUN14NFe"
                          :checked="
                            this.produto.ProdutoAdicional.utiliza_dun14_nfe ===
                            '1'
                          "
                          @change="
                            this.produto.ProdutoAdicional.utiliza_dun14_nfe =
                              this.produto.ProdutoAdicional
                                .utiliza_dun14_nfe === '1'
                                ? '0'
                                : '1'
                          "
                        />
                        <label
                          class="form-check-label fw-bold"
                          for="idUtilizaDUN14NFe"
                          >Utiliza DUN14 NF-e</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="d-flex flex-column col-sm-12 col-md-12 col-lg-12 col-xl-5 col-xxl-5 mb-4"
                  >
                    <h4 class="text-primary ms-4 mt-4">Imagem do Produto</h4>
                    <div
                      class="d-flex align-items-center justify-content-center card border border-rounded border-gray-300 mb-2 mt-4 p-6 flex-grow-1"
                    >
                      <div class="d-flex flex-column align-items-center">
                        <div
                          id="imgImagem"
                          class="image-input image-input-outline"
                          data-kt-image-input="true"
                        >
                          <div
                            class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                            v-if="this.produto.imagem"
                            :style="{
                              'background-image': `url(${produto.imagem})`,
                            }"
                            style="cursor: pointer"
                            @click="$refs.fileInput.click()"
                          ></div>
                          <div
                            class="image-input-wrapper imagePreviewWrapper w-150px h-150px"
                            v-else
                            :style="{
                              'background-image': `url(media/svg/files/blank-image.svg)`,
                            }"
                            style="cursor: pointer"
                            data-bs-dismiss="click"
                            @click="$refs.fileInput.click()"
                          ></div>
                          <label
                            class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                            data-kt-image-input-action="change"
                            data-bs-toggle="tooltip"
                            data-bs-dismiss="click"
                            title="Alterar imagem"
                          >
                            <i class="bi bi-pencil-fill fs-7"></i>
                            <input
                              ref="fileInput"
                              type="file"
                              name="avatar"
                              accept=".png, .jpg, .jpeg"
                              @input="pickFile"
                            />
                            <input type="hidden" name="avatar_remove" />
                          </label>
                          <span
                            class="btn btn-icon btn-circle btn-active-color-primary w-30px h-30px bg-white shadow"
                            data-kt-image-input-action="remove"
                            data-bs-toggle="tooltip"
                            @click="removerImagem()"
                            data-bs-dismiss="click"
                            title="Remover imagem"
                          >
                            <i class="bi bi-x fs-2"></i>
                          </span>
                        </div>
                        <div class="form-text mt-6 text-center">
                          Selecione a imagem do produto. Apenas *.png, *.jpg e
                          *.jpeg aquivos de imagem são aceitos
                        </div>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{ errosValidacao["imagem"] }}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="col-sm-12 col-md-12 col-lg-12 col-xl-7 col-xxl-7">
                    <el-divider content-position="left"
                      ><h4 class="text-primary">Aplicação</h4></el-divider
                    >
                    <div class="row">
                      <div
                        class="col-sm-12 col-md-4 col-lg-4 col-xl-12 col-xxl-4 mb-4"
                      >
                        <div class="fv-row">
                          <label class="form-label">Código do fabricante</label>
                          <input
                            id="txtCodFabricante"
                            type="text"
                            class="form-control mb-2"
                            v-model="
                              this.produto.ProdutoAdicional.cod_fabricante
                            "
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              errosValidacao["ProdutoAdicionalcod_fabricante"]
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-8 col-lg-8 col-xl-12 col-xxl-8 mb-4"
                      >
                        <div class="fv-row">
                          <label class="form-label">Aplicação</label>
                          <input
                            id="txtAplicacao"
                            type="text"
                            class="form-control mb-2"
                            v-model="this.produto.ProdutoAdicional.aplicacao"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["ProdutoAdicionalaplicacao"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-4 col-lg-4 col-xl-12 col-xxl-4 mb-4"
                      >
                        <div class="fv-row">
                          <label class="form-label">Código Similaridade</label>
                          <input
                            id="txtCodSimilaridade"
                            type="text"
                            class="form-control mb-2"
                            v-model="this.produto.ProdutoAdicional.similaridade"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["ProdutoAdicionalsimilaridade"] }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-8 col-lg-8 col-xl-12 col-xxl-8 mb-4"
                      >
                        <div class="fv-row">
                          <label class="form-label">Fornecedor</label>
                          <div class="input-group">
                            <input
                              id="txtFornecedor"
                              type="text"
                              class="form-control"
                              :value="
                                this.produto.ProdutoAdicional.cod_fornecedor
                                  ? this.produto.ProdutoAdicional
                                      .cod_fornecedor +
                                    ' - ' +
                                    this.produto.ProdutoAdicional
                                      .nome_fornecedor
                                  : ''
                              "
                              readonly
                            />
                            <span
                              type="button"
                              class="svg-icon svg-icon-1 position-absolute end-0 me-18 mt-3"
                              @click="limparFornecedorProduto()"
                            >
                              <inline-svg
                                src="media/icons/duotune/arrows/arr061.svg"
                              />
                            </span>
                            <button
                              class="input-group-text"
                              @click="this.modalFornecedores(true)"
                            >
                              <span class="svg-icon svg-icon-2">
                                <inline-svg
                                  src="media/icons/duotune/general/gen004.svg"
                                />
                              </span>
                            </button>
                          </div>
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{
                              errosValidacao["ProdutoAdicionalcod_fornecedor"]
                            }}
                          </div>
                        </div>
                      </div>
                      <div
                        class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                      >
                        <div class="fv-row">
                          <label class="form-label"
                            >Nome do produto no fornecedor</label
                          >
                          <input
                            id="txtNomeProdFornecedor"
                            type="text"
                            class="form-control mb-2"
                            v-model="this.produto.nome_no_fornecedor"
                          />
                          <div
                            class="fv-plugins-message-container invalid-feedback"
                          >
                            {{ errosValidacao["nome_no_fornecedor"] }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Informações adicionais</label>
                      <textarea
                        id="txtInfAdicionais"
                        class="form-control mb-2"
                        placeholder="Informações adicionais do produto"
                        maxlength="300"
                        style="height: 100px"
                        v-model="produto.inf_adicionais"
                      />
                      <div class="row">
                        <div class="col-6 pe-0">
                          <div
                            class="fv-plugins-message-container invalid-feedback m-0"
                          >
                            {{ errosValidacao["inf_adicionais"] }}
                          </div>
                        </div>
                        <div class="col-6 ps-2">
                          <div class="text-end text-muted fs-7">
                            {{
                              produto.inf_adicionais !== null
                                ? produto.inf_adicionais.length
                                : 0
                            }}/300 caracteres
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          class="tab-pane fade"
          id="kt_produto_add_produto_inventario"
          role="tab-panel"
        >
          <div class="d-flex flex-column gap-7 gap-lg-10">
            <div class="card card-flush pt-4">
              <div class="card-body pt-0">
                <el-divider content-position="left"
                  ><h4 class="text-primary mb-0">Configurações</h4>
                </el-divider>
                <div class="row">
                  <div class="d-flex align-items-center col-auto mb-4">
                    <div class="fv-row">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="idUtilizaVariacao"
                          :checked="this.produto.usa_variacao === '1'"
                          @change="
                            this.produto.usa_variacao =
                              this.produto.usa_variacao === '1' ? '0' : '1'
                          "
                        />
                        <label
                          class="form-check-label fw-bold"
                          for="idUtilizaVariacao"
                          >Utiliza variação</label
                        >
                      </div>
                    </div>
                  </div>
                  <div
                    v-if="this.produto.usa_variacao === '1'"
                    class="col-auto mb-4"
                  >
                    <div class="fv-row">
                      <button
                        @click="this.modalVariacaoPadrao(true)"
                        type="button"
                        class="btn-bg-light btn btn-active-light-primary svg-icon-white"
                      >
                        <span class="svg-icon svg-icon-1">
                          <inline-svg
                            src="media/icons/duotune/art/art002.svg"
                          />
                          Definir Variações
                        </span>
                      </button>
                    </div>
                  </div>
                  <div class="d-flex align-items-center col-auto mb-4">
                    <div class="fv-row">
                      <div
                        class="form-check form-switch form-check-custom form-check-solid"
                      >
                        <input
                          class="form-check-input"
                          type="checkbox"
                          id="idUtilizaLotes"
                          :checked="
                            this.produto.ProdutoAdicional.utiliza_lotes === '1'
                          "
                          @change="
                            this.produto.ProdutoAdicional.utiliza_lotes =
                              this.produto.ProdutoAdicional.utiliza_lotes ===
                              '1'
                                ? '0'
                                : '1'
                          "
                        />
                        <label
                          class="form-check-label fw-bold"
                          for="idUtilizaLotes"
                          >Utiliza lotes</label
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div
              class="card card-flush pt-4"
              v-for="(estoque, i) in this.produto.Estoque"
              v-bind:key="i"
            >
              <div class="card-body pt-0">
                <div class="row mt-8">
                  <el-divider class="col-7 mb-8" content-position="left"
                    ><h4 class="text-primary mb-0">Inventário #{{ i + 1 }}</h4>
                    <div class="text-muted fs-7">
                      ID: {{ estoque.id }}
                    </div></el-divider
                  >
                  <el-divider class="col-5 mb-8" content-position="right">
                    <div
                      v-if="
                        this.produto.usa_variacao === '1' ||
                        (produto.ProdutoAdicional &&
                          produto.ProdutoAdicional.utiliza_lotes === '1')
                      "
                      class="row"
                    >
                      <div class="col-6">
                        <button
                          v-if="this.adicionarEstoque"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Adicionar outro inventário"
                          type="button"
                          class="d-flex justify-content-center align-items-center btn-bg-light btn btn-active-light-success svg-icon-white px-3"
                          @click.prevent="adicionarInventario()"
                        >
                          <i class="la la-plus ms-1 mt-1 fs-2"></i>
                        </button>
                      </div>
                      <div class="col-6">
                        <button
                          v-if="this.excluirEstoque"
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Excluír este inventário"
                          type="button"
                          class="d-flex justify-content-center align-items-center btn-bg-light btn btn-active-light-danger svg-icon-white px-3"
                          @click.prevent="excluirInventario(i)"
                        >
                          <i class="la la-trash-o ms-1 fs-2"></i>
                        </button>
                      </div></div
                  ></el-divider>
                </div>
                <div class="row" :ref="`Inventario${i}`">
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Código de barras</label>
                      <input
                        id="txtEstoqueBarras"
                        type="text"
                        class="form-control mb-2"
                        placeholder="Código de barras"
                        v-model="estoque.ean"
                        maxlength="14"
                        :disabled="
                          this.add === false && this.editarEstoque === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao[`Estoque[` + i + `]ean`] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Código PDV (SKU)</label>
                      <input
                        id="txtEstoqueCodReferencia"
                        type="text"
                        class="form-control mb-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="O código PDV é o código de referência da sua aplicação"
                        placeholder="Código PDV (SKU)"
                        v-model="estoque.cod_referencia"
                        maxlength="14"
                        :disabled="
                          this.add === false && this.editarEstoque === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao[`Estoque[` + i + `]cod_referencia`] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Preço de Venda</label>
                      <CurrencyInput
                        class="form-control mb-2"
                        placeholder="Preço de Venda"
                        style="text-align: right"
                        v-model="estoque.preco"
                        :options="options"
                        :disabled="
                          this.add === false && this.editarEstoque === false
                        "
                      ></CurrencyInput>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao[`Estoque[` + i + `]preco`] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-6 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Quantidade</label>
                      <div class="input-group">
                        <CurrencyInput
                          class="form-control"
                          placeholder="Estoque do produto"
                          style="text-align: right"
                          v-model="estoque.qtd"
                          :options="options"
                          disabled
                        ></CurrencyInput>
                        <button
                          data-bs-toggle="tooltip"
                          data-bs-placement="top"
                          title="Movimentar estoque"
                          class="input-group-text"
                          @click="this.movimentarEstoque(i)"
                        >
                          <span class="svg-icon svg-icon-2 svg-icon-primary">
                            <inline-svg
                              src="media/icons/duotune/general/gen017.svg"
                            />
                          </span>
                        </button>
                      </div>
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao[`Estoque[` + i + `]qtd`] }}
                      </div>
                    </div>
                  </div>
                </div>
                <div
                  v-if="
                    produto.ProdutoAdicional &&
                    produto.ProdutoAdicional.utiliza_lotes === '1'
                  "
                  class="row"
                >
                  <div
                    class="col-sm-12 col-md-6 col-lg-12 col-xl-6 col-xxl-6 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Lote</label>
                      <input
                        id="txtLote"
                        type="text"
                        class="form-control mb-2"
                        v-model="estoque.lote"
                        :disabled="
                          this.add === false && this.editarEstoque === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{ errosValidacao[`Estoque[` + i + `]lote`] }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-3 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Data Fabricação</label>
                      <el-date-picker
                        v-model="estoque.data_fabricacao"
                        type="datetime"
                        name="dtpDataFabricacao"
                        placeholder="Selecione uma data"
                        class="w-100"
                        format="DD/MM/YYYY"
                        size="large"
                        :disabled="
                          this.add === false && this.editarEstoque === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao[`Estoque[` + i + `]data_fabricacao`]
                        }}
                      </div>
                    </div>
                  </div>
                  <div
                    class="col-sm-6 col-md-3 col-lg-6 col-xl-3 col-xxl-3 mb-4"
                  >
                    <div class="fv-row">
                      <label class="form-label">Data Vencimento</label>
                      <el-date-picker
                        v-model="estoque.data_vencimento"
                        type="datetime"
                        name="dtpDataVencimento"
                        placeholder="Selecione uma data"
                        class="w-100"
                        format="DD/MM/YYYY"
                        size="large"
                        :disabled="
                          this.add === false && this.editarEstoque === false
                        "
                      />
                      <div
                        class="fv-plugins-message-container invalid-feedback"
                      >
                        {{
                          errosValidacao[`Estoque[` + i + `]data_vencimento`]
                        }}
                      </div>
                    </div>
                  </div>
                </div>
                <div v-if="this.produto.usa_variacao === '1'">
                  <el-divider content-position="left"
                    ><h4 class="text-primary">Variações</h4></el-divider
                  >
                  <div
                    class="row"
                    v-for="(estoqueVariacao, iv) in estoque.EstoqueVariacao"
                    v-bind:key="iv"
                  >
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-5 mb-4"
                    >
                      <div class="fv-row">
                        <label class="form-label">Descrição</label>
                        <select
                          class="form-select mb-0"
                          data-placeholder="Selecione uma opção"
                          v-model="estoqueVariacao.descricao_variacao"
                          disabled
                        >
                          <template
                            v-for="variacao in this.variacoes"
                            :key="variacao.id"
                          >
                            <option :value="variacao.id">
                              {{ variacao.descricao }}
                            </option>
                          </template>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              `Estoque[` +
                                i +
                                `]EstoqueVariacao[` +
                                iv +
                                `]descricao_variacao`
                            ]
                          }}
                        </div>
                      </div>
                    </div>
                    <div
                      class="col-12 col-sm-6 col-md-6 col-lg-6 col-xl-6 col-xxl-5 mb-4"
                    >
                      <div class="fv-row">
                        <div class="d-flex justify-content-between">
                          <label class="form-label">Variação</label>
                          <div class="card-toolbar">
                            <button
                              v-if="this.consultarVariacaoItem"
                              type="button"
                              @click="
                                consultarVariacaoItens(
                                  estoqueVariacao.descricao_variacao
                                )
                              "
                              class="btn btn-sm btn-secondary px-2 py-0 m-0"
                            >
                              <span class="svg-icon svg-icon-1 m-0">
                                <inline-svg
                                  src="media/icons/duotune/general/gen041.svg"
                              /></span>
                            </button>
                          </div>
                        </div>
                        <select
                          class="form-select mb-0"
                          data-placeholder="Selecione uma opção"
                          v-model="estoqueVariacao.valor_variacao"
                          :disabled="
                            this.add === false && this.editarEstoque === false
                          "
                        >
                          <template
                            v-for="variacaoItem in this.carregarVariacaoItens(
                              estoqueVariacao.descricao_variacao
                            )"
                            :key="variacaoItem.id"
                          >
                            <option :value="variacaoItem.id">
                              {{ variacaoItem.descricao }}
                            </option>
                          </template>
                        </select>
                        <div
                          class="fv-plugins-message-container invalid-feedback"
                        >
                          {{
                            errosValidacao[
                              `Estoque[` +
                                i +
                                `]EstoqueVariacao[` +
                                iv +
                                `]valor_variacao`
                            ]
                          }}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-auto mb-4">
                    <button
                      v-if="this.consultarEstoqueImagem"
                      @click="
                        this.modalEditarEstoqueImagem(true),
                          (this.indexEdicaoEstoque = i)
                      "
                      class="btn-bg-light btn btn-active-light-primary svg-icon-white"
                    >
                      <div
                        v-if="this.produto.Estoque[i].EstoqueImagem.length > 0"
                      >
                        <i class="bi bi-images me-2 fs-3"></i
                        >{{
                          "Imagens (" +
                          this.produto.Estoque[i].EstoqueImagem.length +
                          ")"
                        }}
                      </div>
                      <div v-else>
                        <i class="bi bi-images me-2 fs-3"></i>Imagens
                      </div>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <el-dialog
    custom-class="w-auto h-auto w-sm-auto h-sm-auto w-md-50 h-md-auto w-lg-50 h-lg-auto w-xl-500px h-lx-auto"
    v-model="dialogVisible"
  >
    <div class="image-block">
      <el-image
        :key="dialogImageUrl"
        :src="dialogImageUrl"
        fit="cover"
        :style="{
          borderRadius: `6px`,
        }"
      />
    </div>
  </el-dialog>
  <div
    v-if="exibirEditarEstoqueImagem"
    id="kt_modal_estoque_imagem_editar"
    ref="kt_modal_estoque_imagem_editar"
    data-bs-backdrop="static"
    data-bs-focus="false"
    class="modal fade modal-overlay"
    tabindex="-1"
  >
    <div
      class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable"
    >
      <div class="modal-content">
        <div class="modal-header">
          <h3 class="modal-title">Galeria de Imagens</h3>
          <div
            class="btn btn-icon btn-sm btn-active-light-primary"
            data-bs-dismiss="modal"
            @click="this.modalEditarEstoqueImagem(false)"
          >
            <span class="svg-icon svg-icon-2x">
              <img src="media/icons/duotune/arrows/arr061.svg" />
            </span>
          </div>
        </div>
        <div class="modal-body p-8">
          <div class="row">
            <div
              class="col-sm-12 col-md-12 col-lg-12 col-xl-12 col-xxl-12 mb-2"
            >
              <div
                class="mb-10 fv-row text-center bg-light-secondary rounded border-secondary border-2 border-dashed p-3"
              >
                <el-upload
                  :id="`uploadRef${this.indexEdicaoEstoque}`"
                  action="#"
                  list-type="picture-card"
                  :on-preview="handlePictureCardPreview"
                  :before-remove="handleRemove"
                  :on-change="handleUpload"
                  :file-list="
                    this.produto.Estoque[this.indexEdicaoEstoque].EstoqueImagem
                  "
                  :auto-upload="false"
                  accept=".png, .jpg, .jpeg"
                  multiple
                  :limit="10"
                >
                  <i class="la la-plus fs-3x"></i>
                </el-upload>
                <div class="mt-6">
                  Defina a galeria de imagens do produto.
                  <br />Permitido até <b class="text-primary">10 imagens</b> por
                  produto. <br />Apenas
                  <b class="text-danger">*.png, *.jpg e *.jpeg</b>
                  aquivos de imagem são aceitos.
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <AdicionaisModal
    v-if="exibirAdicionais"
    @exibirModalAdicional="modalAdicionais"
    @selecionarAdicional="selecionarAdicional"
  ></AdicionaisModal>
  <AliquotasModal
    v-if="exibirAliquotas"
    @exibirModalAliquotas="modalAliquotas"
    @confirmarAliquota="carregarAliquotas"
  ></AliquotasModal>
  <CfopsModal
    v-if="exibirCfops"
    @exibirModalCfops="modalCfops"
    @selecionarCfop="selecionarCfop"
  ></CfopsModal>
  <CestsModal
    v-if="exibirCests"
    @exibirModalCests="modalCests"
    @selecionarCest="selecionarCest"
  ></CestsModal>
  <TabelaEstadosModal
    v-if="exibirTabelaEstados"
    @exibirModalTabelaEstados="modalTabelaEstados"
    @selecionarTabelaEstado="selecionarTabelaEstado"
  ></TabelaEstadosModal>
  <ServicosCnaeDetsModal
    v-if="exibirServicosCnaeDets"
    @exibirModalServicosCnaeDets="modalServicosCnaeDets"
    @selecionarServicosCnaeDet="selecionarServicosCnaeDet"
  ></ServicosCnaeDetsModal>
  <GeneroSpedsModal
    v-if="exibirGeneroSpeds"
    @exibirModalGeneroSpeds="modalGeneroSpeds"
    @selecionarGeneroSped="selecionarGeneroSped"
  ></GeneroSpedsModal>
  <TributacoesModal
    v-if="exibirTributacoes"
    @exibirModalTributacoes="modalTributacoes"
    @selecionarTributacao="selecionarTributacao"
  ></TributacoesModal>
  <IbptsModal
    v-if="exibirIbpts"
    @exibirModalIbpts="modalIbpts"
    @selecionarIbpt="selecionarIbpt"
  ></IbptsModal>
  <TiposEstoqueModal
    v-if="exibirTiposEstoque"
    @exibirModalTiposEstoque="modalTiposEstoque"
    @confirmarTipoEstoque="carregarTipos"
  ></TiposEstoqueModal>
  <GruposModal
    ref="GruposModal"
    v-if="exibirGrupos"
    :modal="true"
    :modalSubGrupo="exibirSubGrupos"
    @exibirModalGrupo="modalGrupos"
    @selecionarGrupo="selecionarGrupo"
    @selecionarSubGrupo="selecionarSubGrupo"
  ></GruposModal>
  <CategoriasEstoqueModal
    v-if="exibirCategoriasEstoque"
    @exibirModalCategoriasEstoque="modalCategoriasEstoque"
    @selecionarCategoriaEstoque="selecionarCategoriaEstoque"
  ></CategoriasEstoqueModal>
  <STModal
    v-if="exibirST"
    :st="this.produto.ProdutoTributacao.st"
    @exibirModalST="modalST"
    @confirmarST="confirmarST"
  ></STModal>
  <CSOSNModal
    v-if="exibirCSOSN"
    :csosn="this.produto.ProdutoTributacao.csosn"
    @exibirModalCSOSN="modalCSOSN"
    @confirmarCSOSN="confirmarCSOSN"
  ></CSOSNModal>
  <ContasModal
    v-if="exibirContas"
    @exibirModalContas="modalContas"
    @selecionarConta="selecionarConta"
  ></ContasModal>
  <CustosModal
    v-if="exibirCustos"
    @exibirModalCustos="modalCustos"
    @selecionarCusto="selecionarCusto"
  ></CustosModal>
  <FornecedoresModal
    v-if="exibirFornecedores"
    @exibirModalFornecedores="modalFornecedores"
    @selecionarFornecedor="selecionarFornecedor"
  ></FornecedoresModal>
  <EstoqueMovimentacaoModal
    v-if="exibirEstoqueMovimentacao"
    :estoque="this.produto.Estoque[this.indexEdicaoEstoque]"
    @exibirModalEstoqueMovimentacao="modalEstoqueMovimentacao"
    @confirmarEstoqueMovimentacao="confirmarEstoqueMovimentacao"
  ></EstoqueMovimentacaoModal>
  <VariacaoPadraoModal
    v-if="exibirVariacaoPadrao"
    :estoque="this.produto.Estoque[0]"
    @exibirModalVariacaoPadrao="modalVariacaoPadrao"
    @confirmarVariacaoPadrao="confirmarVariacaoPadrao"
  ></VariacaoPadraoModal>
  <VariacaoItensModal
    ref="ConsultaVariacaoItens"
    v-if="exibirVariacaoItens"
    :modal="true"
    :idVariacao="this.idVariacao"
    @exibirModalVariacaoItens="modalVariacaoItens"
    @confirmarVariacaoItem="carregarVariacoes"
  ></VariacaoItensModal>
</template>

<script>
import { getOrCreateInstanceModal } from "@/core/helpers/dom";
import { mapState } from "vuex";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import AdicionaisModal from "../adicionais/AdicionaisModal.vue";
import STModal from "../produtos/STModal.vue";
import CSOSNModal from "../produtos/CSOSNModal.vue";
import AliquotasModal from "../produtos/AliquotasModal.vue";
import CfopsModal from "../produtos/CfopsModal.vue";
import CestsModal from "../produtos/CestsModal.vue";
import TabelaEstadosModal from "../produtos/TabelaEstadosModal.vue";
import ServicosCnaeDetsModal from "../produtos/ServicosCnaeDetsModal.vue";
import IbptsModal from "../produtos/IbptsModal.vue";
import GeneroSpedsModal from "../produtos/GeneroSpedsModal.vue";
import TributacoesModal from "../produtos/TributacoesModal.vue";
import TiposEstoqueModal from "../produtos/TiposEstoqueModal.vue";
import GruposModal from "../grupos/GruposModal.vue";
import CategoriasEstoqueModal from "../produtos/CategoriasEstoqueModal.vue";
import ContasModal from "@/views/contas/ContasModal.vue";
import CustosModal from "@/views/custos/CustosModal.vue";
import FornecedoresModal from "@/views/fornecedores/FornecedoresModal.vue";
import EstoqueMovimentacaoModal from "../produtos/EstoqueMovimentacaoModal.vue";
import VariacaoPadraoModal from "../produtos/VariacaoPadraoModal.vue";
import VariacaoItensModal from "../produtos/VariacaoItensModal.vue";
import CurrencyInput from "@/components/text/CurrencyInput";
import _ from "lodash";
import { useToast } from "vue-toastification";
const toast = useToast();

const produtoInicializado = {
  id: 0,
  codigo: 0,
  id_grupo: null,
  id_adicional: null,
  und: "UN",
  ean: "",
  nome: "",
  descricao: "",
  inf_adicionais: "",
  preco: 0,
  preco_promocao: 0,
  promocao_tipo: "0",
  promocao_ativa: "0",
  data_inicio_promocao: null,
  data_fim_promocao: null,
  promocao_dias_semana: "0",
  percentual_desconto: 0,
  serve_pessoas: "0",
  peso: 0,
  imagem: "",
  imagemRemover: "",
  formFile: null,
  cod_referencia: "",
  ativo: "1",
  guid: "",
  tempo_preparo: null,
  ordem: 0,
  id_subgrupo: null,
  ncm: "",
  caracteristica: "",
  data_alteracao_preco: null,
  data_ultima_compra: null,
  data_ultima_venda: null,
  fator: "NULO",
  hora_alteracao: null,
  id_categoria: null,
  local_armazenado: "",
  nome_no_fornecedor: "",
  outro_preco_venda: 0,
  padrao_barras: "EAN13",
  peso_liquido: 0,
  prazo_distribuidora: 0,
  preco_custo: 0,
  preco_custo_medio: 0,
  preco_distribuidora: 0,
  preco_prazo_revenda: 0,
  preco_revenda: 0,
  preco_ultima_compra: 0,
  preco_venda_prazo: 0,
  qtd_maxima: 0,
  qtd_minima: 0,
  qtd_parcelas: "0",
  sincronizar_pedv_mobile: "0",
  tamanho: "",
  tipo: "",
  und_c: "UN",
  usuario_alterou: null,
  usa_variacao: "0",
  Adicional: {},
  Estoque: [
    {
      id: 0,
      id_produto: 0,
      ean: "",
      qtd: 0,
      cod_referencia: "",
      guid: "",
      preco: 0,
      data_fabricacao: null,
      data_vencimento: null,
      lote: "",
      EstoqueVariacao: [],
      EstoqueImagem: [],
    },
  ],
  ProdutoTributacao: {
    id: 0,
    id_produto: 0,
    tipo_tributacao: "Normal",
    st: "000",
    csosn: "0102",
    classificacao_fiscal: "",
    icms: "00,00",
    mva: 0,
    reducao: 0,
    ipi: 0,
    pis_st: "49",
    pis_aliq: 0,
    pis_base: 0,
    pis_subs: 0,
    pis_subs_base: 0,
    cofins_st: "49",
    cofins_aliq: 0,
    cofins_base: 0,
    cofins_subs: 0,
    cofins_subs_base: 0,
    cfop: null,
    cod_genero: "0",
    cod_tipo_sped: "00",
    aliqi: "00,00",
    id_estoque_st: null,
    cod_anp: "",
    por_imposto_prod: 0,
    cest: "0000000",
    cst_ipi: "53",
    aliq_fcp: 0,
    formula_base_st: "",
    formula_icms_st: "",
    cod_servico: "",
    p_gnn: 0,
    p_glp: 0,
    p_gni: 0,
    v_part: 0,
  },
  ProdutoSimulador: {
    id: 0,
    id_produto: 0,
    preco_custo: 0,
    preco_ultima_compra: 0,
    utiliza_custo: "1",
    ipi_compra: 0,
    ipi_venda: 0,
    comissao: 0,
    outros: 0,
    frete: 0,
    operacional: 0,
    lucro_venda: 0,
    lucro_revenda: 0,
    preco_venda: 0,
    preco_revenda: 0,
    icm_venda: 0,
    icm_compra: 0,
    mao_de_obra: 0,
    desconto: 0,
    preco_venda_desconto: 0,
  },
  ProdutoAdicional: {
    id: 0,
    id_produto: 0,
    tipo_produto: "Normal",
    lote: "",
    data_validade: null,
    cod_fabricante: "",
    data_cadastro: null,
    aplicacao: "",
    similaridade: "",
    cod_fornecedor: "",
    nome_fornecedor: "",
    utiliza_lotes: "0",
    id_conta: null,
    id_custo: null,
    dun14: "",
    dun14_ean13: "",
    utiliza_dun14_nfe: "0",
  },
  Grupo: {
    codigo: null,
  },
};

const estoqueVariacaoInicializado = {
  id: 0,
  id_estoque: 0,
  id_produto: 0,
  descricao_variacao: null,
  valor_variacao: null,
  guid: "",
};

const estoqueImagemInicializado = {
  id: 0,
  id_estoque: 0,
  id_produto: 0,
  imagem: "",
  ordem: 0,
  guid: "",
};

export default {
  emits: ["cancelarProduto", "confirmarProduto", "input"],
  components: {
    CurrencyInput,
    AdicionaisModal,
    STModal,
    CSOSNModal,
    AliquotasModal,
    CfopsModal,
    CestsModal,
    TabelaEstadosModal,
    ServicosCnaeDetsModal,
    GeneroSpedsModal,
    TributacoesModal,
    IbptsModal,
    TiposEstoqueModal,
    GruposModal,
    CategoriasEstoqueModal,
    ContasModal,
    CustosModal,
    FornecedoresModal,
    EstoqueMovimentacaoModal,
    VariacaoPadraoModal,
    VariacaoItensModal,
  },
  props: {
    idProduto: { type: Number, required: false, default: 0 },
    modal: { type: Boolean, required: false, default: false },
  },
  methods: {
    modalVariacaoItens(exibir) {
      this.exibirVariacaoItens = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_variacao_itens_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarVariacaoItens");
          },
          /*close*/ () => {
            this.modalVariacaoItens(false);
          }
        );
      }
    },
    consultarVariacaoItens(idVariacao) {
      this.idVariacao = idVariacao;
      this.modalVariacaoItens(true);
    },
    confirmarVariacaoPadrao(variacaoPadrao) {
      for (let i = 0; i < this.produto.Estoque.length; i++) {
        const estoque = this.produto.Estoque[i];
        var estoqueVariacaoOld = estoque.EstoqueVariacao;
        estoque.EstoqueVariacao = [];

        for (const variacao of variacaoPadrao) {
          var estoqueVariacao = JSON.parse(
            JSON.stringify(estoqueVariacaoInicializado)
          );
          estoqueVariacao.descricao_variacao = variacao.descricao_variacao;
          const filterVariacao = estoqueVariacaoOld.filter(
            (item) => item.descricao_variacao === variacao.descricao_variacao
          );
          if (filterVariacao.length > 0) {
            estoqueVariacao.valor_variacao = filterVariacao[0].valor_variacao;
          }
          estoque.EstoqueVariacao.push(estoqueVariacao);
        }
      }
    },
    modalVariacaoPadrao(exibir) {
      this.exibirVariacaoPadrao = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_variacao_padrao",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_variacao_padrao");
          },
          /*close*/ () => {
            this.modalVariacaoPadrao(false);
          }
        );
      }
    },
    async carregarVariacoes() {
      try {
        var ret = await this.$store.dispatch(
          "variacao/getVariacaoOData",
          "?$expand=VariacaoItem"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.variacoes = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    carregarVariacaoItens(idVariacao) {
      const index = this.variacoes.findIndex(
        (variacao) => variacao.id === idVariacao
      );
      if (index >= 0) {
        return this.variacoes[index].VariacaoItem;
      } else {
        return [];
      }
    },
    async movimentarEstoque(index) {
      if (this.adicionarEstoqueMovimentacao === false) {
        await this.$swal.showInvalidAlert(
          "Usuário não tem permissão para movimentar estoque!"
        );
      } else {
        if (this.produto.Estoque[index].id === 0) {
          await this.$swal.showInvalidAlert(
            "Não é possível movimentar o estoque antes de gravar o cadastro!"
          );
        } else {
          this.indexEdicaoEstoque = index;
          this.modalEstoqueMovimentacao(true);
        }
      }
    },
    modalEstoqueMovimentacao(exibir) {
      this.exibirEstoqueMovimentacao = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_estoque_movimentacao",
          /*open*/ () => {
            this.$utils.requestFocus("txtQtdInformada");
          },
          /*close*/ () => {
            this.modalEstoqueMovimentacao(false);
          }
        );
      }
    },
    confirmarEstoqueMovimentacao(qtdFinal) {
      this.produto.Estoque[this.indexEdicaoEstoque].qtd = qtdFinal;
    },
    modalEditarEstoqueImagem(exibir) {
      this.exibirEditarEstoqueImagem = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_estoque_imagem_editar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_estoque_imagem_editar");
          },
          /*close*/ () => {
            this.modalEditarEstoqueImagem(false);
          }
        );
      }
    },
    recalcularPorcPromocao(porcentagem) {
      if (this.produto.preco > 0) {
        if (porcentagem) {
          let resultado = _.floor(
            (this.produto.preco * this.produto.percentual_desconto) / 100,
            2
          );
          this.produto.preco_promocao = _.round(
            this.produto.preco - resultado,
            2
          );
        } else {
          if (this.produto.preco_promocao > 0) {
            let resultado = this.produto.preco - this.produto.preco_promocao;
            this.produto.percentual_desconto = _.round(
              (resultado / this.produto.preco) * 100,
              2
            );
          }
        }
      }
    },
    limparFornecedorProduto() {
      this.produto.ProdutoAdicional.cod_fornecedor = "";
      this.produto.ProdutoAdicional.nome_fornecedor = "";
    },
    selecionarFornecedor(fornecedor) {
      this.produto.ProdutoAdicional.cod_fornecedor = fornecedor.id;
      this.produto.ProdutoAdicional.nome_fornecedor = fornecedor.nome;
    },
    modalFornecedores(exibir) {
      this.exibirFornecedores = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_fornecedores_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarFornecedores");
          },
          /*close*/ () => {
            this.modalFornecedores(false);
          }
        );
      }
    },
    selecionarConta(conta) {
      this.produto.ProdutoAdicional.id_conta = conta.id;
    },
    modalContas(exibir) {
      this.exibirContas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_contas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarContas");
          },
          /*close*/ () => {
            this.modalContas(false);
          }
        );
      }
    },
    selecionarCusto(custo) {
      this.produto.ProdutoAdicional.id_custo = custo.id;
    },
    modalCustos(exibir) {
      this.exibirCustos = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_custos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCustos");
          },
          /*close*/ () => {
            this.modalCustos(false);
          }
        );
      }
    },
    nextFocus(id) {
      if (document.getElementById(id) != null) {
        document.getElementById(id).focus();
      }
    },
    calculaTotalDividido() {
      if (this.$utils.isNumber(this.produto.qtd_parcelas)) {
        if (this.produto.qtd_parcelas > 0) {
          this.totalDividido = this.produto.preco / this.produto.qtd_parcelas;
        } else {
          this.totalDividido = 0;
        }
      } else {
        this.totalDividido = 0;
      }
    },
    selecionarGrupo(grupo) {
      if (this.produto.id_grupo != grupo.id) {
        this.produto.id_grupo = grupo.id;
        this.produto.id_subgrupo = null;

        if (!this.produto.Grupo) {
          this.produto.Grupo = JSON.parse(
            JSON.stringify(produtoInicializado.Grupo)
          );
        }

        this.produto.Grupo.codigo = grupo.codigo;
      }
    },
    modalGrupos(exibir) {
      this.exibirGrupos = exibir;
      this.exibirSubGrupos = false;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_grupos_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarGrupos");
          },
          /*close*/ () => {
            this.modalGrupos(false);
          }
        );
      }
    },
    selecionarSubGrupo(subGrupo) {
      this.produto.id_subgrupo = subGrupo.id;
    },
    consultaSubGrupos() {
      this.exibirGrupos = true;
      this.exibirSubGrupos = true;
      setTimeout(() => {
        this.$refs.GruposModal.exibirSubGrupo(this.produto.id_grupo);
      }, 100);
    },
    selecionarCategoriaEstoque(categoriaEstoque) {
      this.produto.id_categoria = categoriaEstoque.id;
      this.modalCategoriasEstoque(false);
    },
    modalCategoriasEstoque(exibir) {
      this.exibirCategoriasEstoque = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_categorias_estoque_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCategoriasEstoque");
          },
          /*close*/ () => {
            this.modalCategoriasEstoque(false);
          }
        );
      }
    },
    async carregarConfiguracoes() {
      try {
        var ret = await this.$store.dispatch(
          "configuracao/getConfiguracaoOData",
          "?$select=estoque_tipo_lucro"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.configuracao = ret.value[0];
        }
      } catch (error) {
        console.log(error);
      }
    },
    async carregarLabelDescricao() {
      try {
        var ret = await this.$store.dispatch(
          "labelDescricao/getLabelDescricaoOData",
          "?$select=campo,descricao&$filter=modulo eq 'Produtos'"
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.labelDescricao = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    retornaLabelDescricao(campo) {
      var label = this.labelDescricao.find(
        (element) => element.campo === campo
      );
      return label ? label.descricao : "";
    },
    async carregarTipos() {
      try {
        var ret = await this.$store.dispatch(
          "tipoEstoque/getTipoEstoqueOData",
          ""
        );
        if (ret.value !== null && ret.value.length > 0) {
          this.tipos = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalTiposEstoque(exibir) {
      this.exibirTiposEstoque = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tipos_estoque_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarTiposEstoque");
          },
          /*close*/ () => {
            this.modalTiposEstoque(false);
          }
        );
      }
    },
    selecionarIbpt(ibpt) {
      this.produto.ncm = ibpt.ncm;
      this.modalIbpts(false);
    },
    modalIbpts(exibir) {
      this.exibirIbpts = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_ibpts_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarIbpts");
          },
          /*close*/ () => {
            this.modalIbpts(false);
          }
        );
      }
    },
    async selecionarTributacao(tributacao) {
      try {
        var ret = await this.$store.dispatch(
          "tributacoes/getTributacoes",
          tributacao.id
        );
        if (ret.Success === true) {
          tributacao = ret.Data;
          this.produto.ProdutoTributacao.tipo_tributacao =
            tributacao.tipo_tributacao;
          this.produto.ProdutoTributacao.st = tributacao.st;
          this.produto.ProdutoTributacao.csosn = tributacao.csosn;
          this.produto.ProdutoTributacao.classificacao_fiscal =
            tributacao.classificacao_fiscal;
          this.produto.ProdutoTributacao.por_imposto_prod =
            tributacao.por_imposto_prod;
          this.produto.ProdutoTributacao.icms = tributacao.icms;
          this.produto.ProdutoTributacao.mva = tributacao.mva;
          this.produto.ProdutoTributacao.reducao = tributacao.reducao;
          this.produto.ProdutoTributacao.ipi = tributacao.ipi;
          this.produto.ProdutoTributacao.pis_st = tributacao.pis_st;
          this.produto.ProdutoTributacao.pis_aliq = tributacao.pis_aliq;
          this.produto.ProdutoTributacao.cofins_st = tributacao.cofins_st;
          this.produto.ProdutoTributacao.cofins_aliq = tributacao.cofins_aliq;
          this.produto.ProdutoTributacao.cfop = tributacao.cfop;
          this.produto.ProdutoTributacao.cod_genero = tributacao.cod_genero;
          this.produto.ProdutoTributacao.aliqi = tributacao.aliqi;
          this.produto.ProdutoTributacao.id_estoque_st =
            tributacao.id_estoque_st;
          this.produto.ProdutoTributacao.cod_tipo_sped =
            tributacao.tipo_produto;
          this.modalTributacoes(false);
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalTributacoes(exibir) {
      this.exibirTributacoes = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tributacoes_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarTributacoes");
          },
          /*close*/ () => {
            this.modalTributacoes(false);
          }
        );
      }
    },
    selecionarGeneroSped(generoSped) {
      this.produto.ProdutoTributacao.cod_genero = generoSped.codigo;
      this.modalGeneroSpeds(false);
    },
    modalGeneroSpeds(exibir) {
      this.exibirGeneroSpeds = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_genero_speds_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarGeneroSpeds");
          },
          /*close*/ () => {
            this.modalGeneroSpeds(false);
          }
        );
      }
    },
    selecionarServicosCnaeDet(servicosCnaeDet) {
      this.produto.ProdutoTributacao.cod_servico = servicosCnaeDet.codigo;
      this.modalServicosCnaeDets(false);
    },
    modalServicosCnaeDets(exibir) {
      this.exibirServicosCnaeDets = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_servicos_cnae_dets_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarServicosCnaeDets");
          },
          /*close*/ () => {
            this.modalServicosCnaeDets(false);
          }
        );
      }
    },
    limparTabelaEstados() {
      this.produto.ProdutoTributacao.id_estoque_st = null;
    },
    selecionarTabelaEstado(estoqueSt) {
      this.produto.ProdutoTributacao.id_estoque_st = estoqueSt.id;
      this.modalTabelaEstados(false);
    },
    modalTabelaEstados(exibir) {
      this.exibirTabelaEstados = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_tabela_estados_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarEstoqueSts");
          },
          /*close*/ () => {
            this.modalTabelaEstados(false);
          }
        );
      }
    },
    selecionarCest(cest) {
      this.produto.ProdutoTributacao.cest = cest.cest;
      this.modalCests(false);
    },
    modalCests(exibir) {
      this.exibirCests = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_cests_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCests");
          },
          /*close*/ () => {
            this.modalCests(false);
          }
        );
      }
    },
    selecionarCfop(cfop) {
      this.produto.ProdutoTributacao.cfop = cfop.codigo;
      this.modalCfops(false);
    },
    modalCfops(exibir) {
      this.exibirCfops = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_cfops_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarCfops");
          },
          /*close*/ () => {
            this.modalCfops(false);
          }
        );
      }
    },
    async carregarAliquotas() {
      try {
        var ret = await this.$store.dispatch("aliquota/getAliquotaOData", "");
        if (ret.value !== null && ret.value.length > 0) {
          this.aliquotas = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    modalAliquotas(exibir) {
      this.exibirAliquotas = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_aliquotas_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarAliquotas");
          },
          /*close*/ () => {
            this.modalAliquotas(false);
          }
        );
      }
    },
    confirmarCSOSN(csosn) {
      this.produto.ProdutoTributacao.csosn = csosn;
      this.modalCSOSN(false);
    },
    modalCSOSN(exibir) {
      this.exibirCSOSN = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_csosn_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_csosn_consultar");
          },
          /*close*/ () => {
            this.modalCSOSN(false);
          }
        );
      }
    },
    confirmarST(st) {
      this.produto.ProdutoTributacao.st = st;
      this.modalST(false);
    },
    modalST(exibir) {
      this.exibirST = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_st_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("kt_modal_st_consultar");
          },
          /*close*/ () => {
            this.modalST(false);
          }
        );
      }
    },
    atualizaTipoTributacao(tipo) {
      if (tipo === "Normal") {
        this.produto.ProdutoTributacao.st = "000";
        this.produto.ProdutoTributacao.csosn = "0102";
      } else if (tipo === "Substituição Tributária") {
        this.produto.ProdutoTributacao.st = "060";
        this.produto.ProdutoTributacao.csosn = "0500";
      } else if (tipo === "Isenção") {
        this.produto.ProdutoTributacao.st = "040";
        this.produto.ProdutoTributacao.csosn = "0103";
      } else if (tipo === "Não Incidência") {
        this.produto.ProdutoTributacao.st = "041";
        this.produto.ProdutoTributacao.csosn = "0400";
      }
    },
    adicionarInventario() {
      var estoque = JSON.parse(JSON.stringify(produtoInicializado.Estoque[0]));

      for (const variacao of this.produto.Estoque[0].EstoqueVariacao) {
        var estoqueVariacao = JSON.parse(
          JSON.stringify(estoqueVariacaoInicializado)
        );
        estoqueVariacao.descricao_variacao = variacao.descricao_variacao;
        estoque.EstoqueVariacao.push(estoqueVariacao);
      }

      this.produto.Estoque.push(estoque);

      this.scrollRef = "Inventario" + (this.produto.Estoque.length - 1);
      setTimeout(this.scrollFor, 200);
    },
    async excluirInventario(i) {
      if (this.produto.Estoque.length > 1) {
        await this.$swal.showQuestionAlert(
          "Deseja remover o registro?",
          async (alert) => {
            if (alert.isConfirmed) {
              this.errosGerais = {};
              this.errosValidacaoGeral = [];
              this.isLoading = true;

              var id = this.produto.Estoque[i].id;
              if (id === 0) {
                this.produto.Estoque.splice(i, 1);
              } else {
                try {
                  var ret = await this.$store.dispatch(
                    "estoque/deleteEstoque",
                    id
                  );
                  if (ret.Success === true) {
                    this.produto.Estoque.splice(i, 1);
                  }
                } catch (error) {
                  this.errosGerais = error;
                }
              }
              if (this.errosGerais.Message) {
                this.scroll("errosGerais");
              }
              this.isLoading = false;
            }
          }
        );
      }
    },
    async handleUpload(file) {
      let result = true;
      if (this.adicionarEstoqueImagem === false) {
        await this.$swal.showInvalidAlert(
          "Usuário não tem permissão para adicionar imagem!",
          (alert) => {
            result = false;
          }
        );
      } else {
        const reader = new FileReader();
        reader.onload = (event) => {
          file.url = event.target.result;
        };
        reader.readAsDataURL(file.raw);
      }
      return result;
    },
    async handleRemove(file) {
      let result = true;
      if (this.excluirEstoqueImagem === false) {
        await this.$swal.showInvalidAlert(
          "Usuário não tem permissão para excluir imagem!",
          (alert) => {
            result = false;
          }
        );
      } else {
        this.errosGerais = {};
        //this.isLoading = true;
        if (file.id !== 0 && file.id !== undefined) {
          try {
            await this.$store.dispatch(
              "estoqueImagem/deleteEstoqueImagem",
              file.id
            );
          } catch (error) {
            this.errosGerais = error;
          }
        }
        if (this.errosGerais.Message) {
          this.scroll("errosGerais");
        }
        //this.isLoading = false;
      }
      return result;
    },
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },
    modalAdicionais(exibir) {
      this.exibirAdicionais = exibir;
      if (exibir === true) {
        getOrCreateInstanceModal(
          "kt_modal_adicionais_consultar",
          /*open*/ () => {
            this.$utils.requestFocus("txtPesquisarAdicionais");
          },
          /*close*/ () => {
            this.modalAdicionais(false);
          }
        );
      }
    },
    selecionarAdicional(adicional) {
      this.adicionalSelecionado = adicional;
      this.modalAdicionais(false);
    },
    async carregarGrupos() {
      var filtro = "?&expand=subgrupo";
      try {
        var ret = await this.$store.dispatch("grupo/getGrupoOData", filtro);
        if (ret.value !== null && ret.value.length > 0) {
          this.grupos = ret.value;
        }
      } catch (error) {
        console.log(error);
      }
    },
    removerImagem() {
      if (this.add === true) {
        this.produto.imagemRemover = "";
      } else {
        this.produto.imagemRemover = this.produto.imagem.replace(
          this.$utils.getUrl(),
          ""
        );
      }
      this.produto.imagem = "";
      this.produto.formFile = null;
      this.$refs.fileInput.value = null;
    },
    pickFile() {
      let input = this.$refs.fileInput;
      let file = input.files;
      if (file && file[0]) {
        let reader = new FileReader();
        reader.onload = (e) => {
          if (this.produto.imagem !== null) {
            this.produto.imagemRemover = this.produto.imagem.replace(
              this.$utils.getUrl(),
              ""
            );
          }

          this.produto.imagem = e.target.result;
          this.produto.formFile = file[0];
        };
        reader.readAsDataURL(file[0]);
        this.$emit("input", file[0]);
      }
    },
    async confirmar() {
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
      this.isLoading = true;
      this.loadingConfirmar = true;
      this.confirmouCadastro = true;

      this.produto.imagem =
        this.produto.imagem === null
          ? ""
          : this.produto.imagem.replace(this.$utils.getUrl(), "");

      this.produto.id_adicional = this.adicionalSelecionado.id;

      var promocaoDias = "";
      this.diasPromocao
        .filter((x) => x.selecionado === true)
        .forEach((e) => {
          promocaoDias += e.dia + ",";
        });

      if (promocaoDias !== "" && promocaoDias.length > 0) {
        promocaoDias = promocaoDias.substring(0, promocaoDias.length - 1);
      }

      this.produto.promocao_dias_semana = promocaoDias;

      if (this.produto.fator === null || this.produto.fator === "") {
        this.produto.fator = "NULO";
      }

      if (
        this.produto.qtd_parcelas === null ||
        this.produto.qtd_parcelas === ""
      ) {
        this.produto.qtd_parcelas = "0";
      }

      for (var i = 0; i < this.produto.Estoque.length; i++) {
        for (var y = 0; y < this.produto.Estoque[i].EstoqueImagem.length; y++) {
          if (this.produto.Estoque[i].EstoqueImagem[y].status === "ready") {
            this.produto.Estoque[i].EstoqueImagem[y].guid =
              this.$utils.generateUuidv4();
            this.produto.Estoque[i].EstoqueImagem[y].formFile =
              this.produto.Estoque[i].EstoqueImagem[y].raw;
            this.produto.Estoque[i].EstoqueImagem[y].imagem =
              this.produto.Estoque[i].EstoqueImagem[y].url;
          }
        }
      }

      if (this.produto.id === 0) {
        this.produto.guid = this.$utils.generateUuidv4();
        var formData = this.$utils.convertModelToFormData(this.produto);
        try {
          var ret = await this.$store.dispatch("produto/postProduto", formData);
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      } else {
        var formDataPut = this.$utils.convertModelToFormData(this.produto);
        try {
          var retPut = await this.$store.dispatch(
            "produto/putProduto",
            formDataPut
          );
        } catch (error) {
          this.errosValidacaoGeral.push(
            ...this.$utils.retornarValoresJson(error)
          );
          this.errosGerais = error;
          this.errosValidacao = error;
          this.confirmouCadastro = false;
        }
      }

      if (
        this.produto.imagem !== "" &&
        !this.produto.imagem.includes("base64")
      ) {
        this.produto.imagem = this.$utils.getUrl() + this.produto.imagem;
      }

      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }

      this.loadingConfirmar = false;
      this.isLoading = false;

      if (this.confirmouCadastro === true) {
        toast.success("Cadastro salvo com sucesso!", { timeout: 2000 });
        if (this.modal === true) {
          this.$emit("confirmarProduto");
        } else {
          this.$router.push("/cadastros/produtos/consultar");
        }
      } else {
        toast.error("Ocorreu uma falha ao gravar o cadastro, verifique!", {
          timeout: 5000,
        });
      }
    },
    scroll(refName) {
      let el = this.$refs[refName];
      if (el) {
        el.scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    scrollFor() {
      let el = this.$refs[this.scrollRef];
      if (el) {
        el[0].scrollIntoView({
          behavior: "smooth",
          block: "center",
          inline: "center",
        });
      }
    },
    limparProduto() {
      this.produto = JSON.parse(JSON.stringify(produtoInicializado));

      this.adicionalSelecionado = {
        id: null,
        descricao: "",
      };

      this.totalDividido = 0;
      this.errosGerais = {};
      this.errosValidacao = [];
      this.errosValidacaoGeral = [];
    },
    async carregarProduto() {
      var id = 0;
      if (this.modal === true) {
        id = this.idProduto;
      } else {
        id = this.$route.params.id;
      }
      try {
        var ret = await this.$store.dispatch("produto/getProduto", id);
        if (ret.Success === true) {
          if (ret.Data !== null) {
            this.produto = ret.Data;

            if (this.produto.imagem !== null && this.produto.imagem !== "") {
              this.produto.imagem = this.$utils.getUrl() + this.produto.imagem;
            }

            if (
              this.produto.promocao_dias_semana !== "" &&
              this.produto.promocao_dias_semana !== null &&
              this.produto.promocao_dias_semana.length > 0
            ) {
              var promocaoDias = this.produto.promocao_dias_semana.split(",");
              promocaoDias.forEach((e) => {
                var idx = this.diasPromocao.findIndex((x) => x.dia == e);
                this.diasPromocao[idx].selecionado = true;
              });
            }

            if (this.produto.Estoque.length > 0) {
              for (var i = 0; i < this.produto.Estoque.length; i++) {
                if (this.produto.Estoque[i].EstoqueImagem.length > 0) {
                  for (
                    var y = 0;
                    y < this.produto.Estoque[i].EstoqueImagem.length;
                    y++
                  ) {
                    if (
                      this.produto.Estoque[i].EstoqueImagem[y].imagem !==
                        null &&
                      this.produto.Estoque[i].EstoqueImagem[y].imagem !== ""
                    ) {
                      Object.assign(this.produto.Estoque[i].EstoqueImagem[y], {
                        url:
                          this.$utils.getUrl() +
                          this.produto.Estoque[i].EstoqueImagem[y].imagem,
                      });
                    }
                  }
                }
              }
            } else {
              this.produto.Estoque.push(
                JSON.parse(JSON.stringify(produtoInicializado.Estoque[0]))
              );
            }

            if (this.produto.ProdutoTributacao === null) {
              this.produto.ProdutoTributacao = JSON.parse(
                JSON.stringify(produtoInicializado.ProdutoTributacao)
              );
            }

            if (this.produto.ProdutoSimulador === null) {
              this.produto.ProdutoSimulador = JSON.parse(
                JSON.stringify(produtoInicializado.ProdutoSimulador)
              );
            }

            if (this.produto.ProdutoAdicional === null) {
              this.produto.ProdutoAdicional = JSON.parse(
                JSON.stringify(produtoInicializado.ProdutoAdicional)
              );
            }

            if (
              this.produto.id_adicional !== null &&
              this.produto.id_adicional !== ""
            ) {
              this.adicionalSelecionado.id = this.produto.id_adicional;
              this.adicionalSelecionado.descricao =
                this.produto.Adicional.descricao;
            }

            this.produto.Grupo = JSON.parse(
              JSON.stringify(produtoInicializado.Grupo)
            );

            if (
              this.produto.id_grupo !== null &&
              this.produto.id_grupo !== ""
            ) {
              var grupo = await this.carregarGrupo(this.produto.id_grupo);
              this.produto.Grupo.codigo = grupo.codigo;
            }
          } else {
            this.errosGerais = {
              message: "Nenhum produto foi encontrato com o ID informado!",
            };
          }
        }
      } catch (error) {
        this.errosGerais = error;
      }
      if (this.errosGerais.Message) {
        this.scroll("errosGerais");
      }
      this.isLoading = false;
    },
    // convertTime(time) {
    //   var hora = time.Hours < 10 ? "0" + time.Hours : time.Hours;
    //   var min = time.Minutes < 10 ? "0" + time.Minutes : time.Minutes;
    //   var seg = time.Seconds < 10 ? "0" + time.Seconds : time.Seconds;
    //   return hora + ":" + min + ":" + seg;
    // },
    async carregarGrupo(id) {
      var grupo = null;
      try {
        var ret = await this.$store.dispatch("grupo/getGrupo", id);
        if (ret.Success === true) {
          grupo = ret.Data;
        }
      } catch (error) {
        console.log(error);
      }
      return grupo;
    },
    async asyncData() {
      this.isLoading = true;
      await this.carregarConfiguracoes();
      if (
        (this.$route.name.includes("cadastros/produtos/editar") &&
          this.$route.params.id !== undefined) ||
        this.idProduto !== 0
      ) {
        this.add = false;
        await this.carregarProduto();
      } else {
        this.add = true;
        await this.limparProduto();

        if (this.$route.query.grupo !== undefined) {
          this.produto.id_grupo = parseInt(this.$route.query.grupo);
        }
      }
      this.isLoading = false;
      this.confirmouCadastro = true;
      this.carregarAliquotas();
      this.carregarTipos();
      this.carregarVariacoes();
      this.carregarLabelDescricao();
    },
    async verificarRestricoes() {
      if (this.user.User.EmitenteTipoUsuario.EmitenteRestricao != null) {
        this.user.User.EmitenteTipoUsuario.EmitenteRestricao.find((element) => {
          if (element.regra === "Permitir.Adicional.Consultar") {
            this.consultarAdicional = true;
          }

          if (element.regra === "Permitir.Estoque.Consultar") {
            this.consultarEstoque = true;
          }
          if (element.regra === "Permitir.Estoque.Incluir") {
            this.adicionarEstoque = true;
          }
          if (element.regra === "Permitir.Estoque.Alterar") {
            this.editarEstoque = true;
          }
          if (element.regra === "Permitir.Estoque.Excluir") {
            this.excluirEstoque = true;
          }

          if (element.regra === "Permitir.EstoqueImagem.Consultar") {
            this.consultarEstoqueImagem = true;
          }
          if (element.regra === "Permitir.EstoqueImagem.Incluir") {
            this.adicionarEstoqueImagem = true;
          }
          if (element.regra === "Permitir.EstoqueImagem.Excluir") {
            this.excluirEstoqueImagem = true;
          }

          if (element.regra === "Permitir.EstoqueMovimentacao.Incluir") {
            this.adicionarEstoqueMovimentacao = true;
          }

          if (element.regra === "Permitir.VariacaoItem.Consultar") {
            this.consultarVariacaoItem = true;
          }
        });
      }
    },
    recalcularLucroDesconto(value) {
      let preco = parseFloat(value.replace(",", "."));
      let lucro = 0;

      let tipoCalculo = this.configuracao.estoque_tipo_lucro;
      let utilizaCusto = this.produto.ProdutoSimulador.utiliza_custo;
      let precoCusto = this.produto.ProdutoSimulador.preco_custo;
      let precoUltCompra = this.produto.ProdutoSimulador.preco_ultima_compra;
      let ipiCompra = this.produto.ProdutoSimulador.ipi_compra;
      let ipiVenda = this.produto.ProdutoSimulador.ipi_venda;
      let comissao = this.produto.ProdutoSimulador.comissao;
      let outros = this.produto.ProdutoSimulador.outros;
      let frete = this.produto.ProdutoSimulador.frete;
      let operacional = this.produto.ProdutoSimulador.operacional;
      let icmVenda = this.produto.ProdutoSimulador.icm_venda;
      let icmCompra = this.produto.ProdutoSimulador.icm_compra;
      let maoObra = this.produto.ProdutoSimulador.mao_de_obra;

      if (tipoCalculo === "2") {
        let valorCalculadoVenda = 0;
        if (utilizaCusto === "1") {
          valorCalculadoVenda = _.round(precoCusto, 2);
        } else {
          valorCalculadoVenda = _.round(precoUltCompra, 2);
        }

        valorCalculadoVenda = _.round(
          (ipiCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (ipiVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (comissao * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (outros * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (frete * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (icmVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (icmCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (maoObra * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (operacional * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );

        lucro = _.round(
          ((preco - valorCalculadoVenda) * 100) / valorCalculadoVenda,
          2
        );
      }

      this.produto.ProdutoSimulador.lucro_venda = lucro;
    },
    recalcularLucro(value, isLucroVenda) {
      let preco = parseFloat(value.replace(",", "."));
      let lucro = 0;

      let tipoCalculo = this.configuracao.estoque_tipo_lucro;
      let utilizaCusto = this.produto.ProdutoSimulador.utiliza_custo;
      let precoCusto = this.produto.ProdutoSimulador.preco_custo;
      let precoUltCompra = this.produto.ProdutoSimulador.preco_ultima_compra;
      let ipiCompra = this.produto.ProdutoSimulador.ipi_compra;
      let ipiVenda = this.produto.ProdutoSimulador.ipi_venda;
      let comissao = this.produto.ProdutoSimulador.comissao;
      let outros = this.produto.ProdutoSimulador.outros;
      let frete = this.produto.ProdutoSimulador.frete;
      let operacional = this.produto.ProdutoSimulador.operacional;
      let icmVenda = this.produto.ProdutoSimulador.icm_venda;
      let icmCompra = this.produto.ProdutoSimulador.icm_compra;
      let maoObra = this.produto.ProdutoSimulador.mao_de_obra;
      let desconto = this.produto.ProdutoSimulador.desconto;

      if (tipoCalculo === "0") {
        if (utilizaCusto === "1") {
          lucro = ((preco - precoCusto) * 100) / precoCusto;
        } else {
          lucro = ((preco - precoUltCompra) * 100) / precoUltCompra;
        }
      } else if (tipoCalculo === "1") {
        if (utilizaCusto === "1") {
          let resultado = 0;
          let valorCalculadoCusto = 0;
          valorCalculadoCusto = (precoCusto * ipiCompra) / 100 + precoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * ipiVenda) / 100 + valorCalculadoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * frete) / 100 + valorCalculadoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * icmVenda) / 100 + valorCalculadoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * icmCompra) / 100 + valorCalculadoCusto;

          resultado =
            _.round(100 - (valorCalculadoCusto / preco) * 100, 2) -
            comissao -
            outros -
            operacional -
            maoObra -
            desconto;

          if (resultado < 0) {
            lucro = 0;
          } else {
            lucro = resultado;
          }
        } else {
          let resultado = 0;
          let valorCalculadoCusto = 0;
          valorCalculadoCusto =
            (precoUltCompra * ipiCompra) / 100 + precoUltCompra;
          valorCalculadoCusto =
            (valorCalculadoCusto * ipiVenda) / 100 + valorCalculadoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * frete) / 100 + valorCalculadoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * icmVenda) / 100 + valorCalculadoCusto;
          valorCalculadoCusto =
            (valorCalculadoCusto * icmCompra) / 100 + valorCalculadoCusto;

          resultado =
            _.round(100 - (valorCalculadoCusto / preco) * 100, 2) -
            comissao -
            outros -
            operacional -
            maoObra -
            desconto;

          if (resultado < 0) {
            lucro = 0;
          } else {
            lucro = resultado;
          }
        }
      } else if (tipoCalculo === "3") {
        if (utilizaCusto === "1") {
          let resultado = 0;

          resultado =
            _.round(100 - (precoCusto / preco) * 100, 2) -
            comissao -
            outros -
            operacional -
            maoObra -
            desconto -
            ipiCompra -
            ipiVenda -
            frete -
            icmVenda -
            icmCompra;

          if (resultado < 0) {
            lucro = 0;
          } else {
            lucro = resultado;
          }
        } else {
          let resultado = 0;

          resultado =
            _.round(100 - (precoUltCompra / preco) * 100, 2) -
            comissao -
            outros -
            operacional -
            maoObra -
            desconto -
            ipiCompra -
            ipiVenda -
            frete -
            icmVenda -
            icmCompra;

          if (resultado < 0) {
            lucro = 0;
          } else {
            lucro = resultado;
          }
        }
      } else if (tipoCalculo === "2") {
        let valorCalculadoVenda = 0;
        if (utilizaCusto === "1") {
          valorCalculadoVenda = _.round(precoCusto, 2);
        } else {
          valorCalculadoVenda = _.round(precoUltCompra, 2);
        }

        valorCalculadoVenda = _.round(
          (ipiCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (ipiVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (comissao * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (outros * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (frete * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (icmVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (icmCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (maoObra * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (operacional * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );
        valorCalculadoVenda = _.round(
          (desconto * valorCalculadoVenda) / 100 + valorCalculadoVenda,
          4
        );

        lucro = _.round(
          ((preco - valorCalculadoVenda) * 100) / valorCalculadoVenda,
          2
        );
      }

      if (isLucroVenda) {
        this.produto.ProdutoSimulador.lucro_venda = lucro;
      } else {
        this.produto.ProdutoSimulador.lucro_revenda = lucro;
      }
    },
  },
  async mounted() {
    await this.verificarRestricoes();
    this.asyncData();
  },
  watch: {
    $route: {
      handler: "asyncData",
      immediate: true,
    },
    precoVendaCalculado(newVal) {
      this.produto.ProdutoSimulador.preco_venda = newVal;
    },
    precoRevendaCalculado(newVal) {
      this.produto.ProdutoSimulador.preco_revenda = newVal;
    },
    precoVendaDescontoCalculado(newVal) {
      this.produto.ProdutoSimulador.preco_venda_desconto = newVal;
    },
  },
  computed: {
    ...mapState("auth", ["user"]),
    precoRevendaCalculado() {
      let tipoCalculo = this.configuracao.estoque_tipo_lucro;
      let utilizaCusto = this.produto.ProdutoSimulador.utiliza_custo;
      let precoCusto = this.produto.ProdutoSimulador.preco_custo;
      let precoUltCompra = this.produto.ProdutoSimulador.preco_ultima_compra;
      let lucroRevenda = this.produto.ProdutoSimulador.lucro_revenda;

      if (tipoCalculo === "0") {
        if (utilizaCusto === "1") {
          return (precoCusto * lucroRevenda) / 100 + precoCusto;
        } else {
          return (precoUltCompra * lucroRevenda) / 100 + precoUltCompra;
        }
      } else if (tipoCalculo === "1" || tipoCalculo === "3") {
        if (utilizaCusto === "1") {
          return this.calculaPrecoLiquido(precoCusto, lucroRevenda);
        } else {
          return this.calculaPrecoLiquido(precoUltCompra, lucroRevenda);
        }
      } else {
        if (utilizaCusto === "1") {
          return this.calculaPrecoCumulativo(precoCusto, lucroRevenda);
        } else {
          return this.calculaPrecoCumulativo(precoUltCompra, lucroRevenda);
        }
      }
    },
    precoVendaCalculado() {
      let tipoCalculo = this.configuracao.estoque_tipo_lucro;
      let utilizaCusto = this.produto.ProdutoSimulador.utiliza_custo;
      let precoCusto = this.produto.ProdutoSimulador.preco_custo;
      let precoUltCompra = this.produto.ProdutoSimulador.preco_ultima_compra;
      let lucroVenda = this.produto.ProdutoSimulador.lucro_venda;

      if (tipoCalculo === "0") {
        if (utilizaCusto === "1") {
          return (precoCusto * lucroVenda) / 100 + precoCusto;
        } else {
          return (precoUltCompra * lucroVenda) / 100 + precoUltCompra;
        }
      } else if (tipoCalculo === "1" || tipoCalculo === "3") {
        if (utilizaCusto === "1") {
          return this.calculaPrecoLiquido(precoCusto, lucroVenda);
        } else {
          return this.calculaPrecoLiquido(precoUltCompra, lucroVenda);
        }
      } else {
        if (utilizaCusto === "1") {
          return this.calculaPrecoCumulativo(precoCusto, lucroVenda);
        } else {
          return this.calculaPrecoCumulativo(precoUltCompra, lucroVenda);
        }
      }
    },
    precoVendaDescontoCalculado() {
      let tipoCalculo = this.configuracao.estoque_tipo_lucro;
      let utilizaCusto = this.produto.ProdutoSimulador.utiliza_custo;
      let precoCusto = this.produto.ProdutoSimulador.preco_custo;
      let precoUltCompra = this.produto.ProdutoSimulador.preco_ultima_compra;
      let lucroVenda = this.produto.ProdutoSimulador.lucro_venda;
      let desconto = this.produto.ProdutoSimulador.desconto;

      if (tipoCalculo === "2") {
        if (utilizaCusto === "1") {
          let valorCalculadoDesconto = this.calculaPrecoCumulativo(
            precoCusto,
            lucroVenda
          );
          valorCalculadoDesconto =
            valorCalculadoDesconto - (desconto * valorCalculadoDesconto) / 100;

          return _.round(valorCalculadoDesconto, 2);
        } else {
          let valorCalculadoDesconto = this.calculaPrecoCumulativo(
            precoUltCompra,
            lucroVenda
          );
          valorCalculadoDesconto =
            valorCalculadoDesconto - (desconto * valorCalculadoDesconto) / 100;

          return _.round(valorCalculadoDesconto, 2);
        }
      } else {
        return 0;
      }
    },
    calculaPrecoLiquido() {
      return (preco, lucro) => {
        let tipoCalculo = this.configuracao.estoque_tipo_lucro;
        let ipiCompra = this.produto.ProdutoSimulador.ipi_compra;
        let ipiVenda = this.produto.ProdutoSimulador.ipi_venda;
        let comissao = this.produto.ProdutoSimulador.comissao;
        let outros = this.produto.ProdutoSimulador.outros;
        let frete = this.produto.ProdutoSimulador.frete;
        let operacional = this.produto.ProdutoSimulador.operacional;
        let icmVenda = this.produto.ProdutoSimulador.icm_venda;
        let icmCompra = this.produto.ProdutoSimulador.icm_compra;
        let maoObra = this.produto.ProdutoSimulador.mao_de_obra;
        let desconto = this.produto.ProdutoSimulador.desconto;

        if (tipoCalculo === "1") {
          let calculadoVenda =
            (preco /
              (100 -
                comissao -
                outros -
                operacional -
                maoObra -
                desconto -
                lucro)) *
            100;
          let valorCalculadoVenda = _.round(calculadoVenda, 2);

          valorCalculadoVenda =
            (ipiCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda;
          valorCalculadoVenda =
            (ipiVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda;
          valorCalculadoVenda =
            (frete * valorCalculadoVenda) / 100 + valorCalculadoVenda;
          valorCalculadoVenda =
            (icmVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda;
          valorCalculadoVenda =
            (icmCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda;

          return _.round(valorCalculadoVenda, 2);
        } else if (tipoCalculo === "3") {
          let calculadoVenda =
            (preco /
              (100 -
                comissao -
                outros -
                operacional -
                maoObra -
                desconto -
                lucro -
                ipiCompra -
                ipiVenda -
                frete -
                icmVenda -
                icmCompra)) *
            100;
          let valorCalculadoVenda = _.round(calculadoVenda, 2);

          return _.round(valorCalculadoVenda, 2);
        }
      };
    },
    calculaPrecoCumulativo() {
      return (preco, lucro) => {
        let ipiCompra = this.produto.ProdutoSimulador.ipi_compra;
        let ipiVenda = this.produto.ProdutoSimulador.ipi_venda;
        let comissao = this.produto.ProdutoSimulador.comissao;
        let outros = this.produto.ProdutoSimulador.outros;
        let frete = this.produto.ProdutoSimulador.frete;
        let operacional = this.produto.ProdutoSimulador.operacional;
        let icmVenda = this.produto.ProdutoSimulador.icm_venda;
        let icmCompra = this.produto.ProdutoSimulador.icm_compra;
        let maoObra = this.produto.ProdutoSimulador.mao_de_obra;
        let desconto = this.produto.ProdutoSimulador.desconto;

        let valorCalculadoVenda = _.round(preco, 2);

        valorCalculadoVenda =
          (ipiCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (ipiVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (comissao * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (outros * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (frete * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (operacional * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (lucro * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (icmVenda * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (icmCompra * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (maoObra * valorCalculadoVenda) / 100 + valorCalculadoVenda;
        valorCalculadoVenda =
          (desconto * valorCalculadoVenda) / 100 + valorCalculadoVenda;

        return _.round(valorCalculadoVenda, 2);
      };
    },
    enableCamposLucro() {
      let tipoCalculo = this.configuracao.estoque_tipo_lucro;
      return tipoCalculo === "1" || tipoCalculo === "2" || tipoCalculo === "3";
    },
  },
  data() {
    return {
      consultarVariacaoItem: false,
      adicionarEstoqueMovimentacao: false,
      timeOut: null,
      consultarEstoqueImagem: false,
      adicionarEstoqueImagem: false,
      excluirEstoqueImagem: false,
      consultarEstoque: false,
      adicionarEstoque: false,
      editarEstoque: false,
      excluirEstoque: false,
      consultarAdicional: false,
      idVariacao: 0,
      exibirVariacaoItens: false,
      configuracao: {},
      labelDescricao: [],
      totalDividido: 0,
      confirmouCadastro: true,
      exibirVariacaoPadrao: false,
      exibirEstoqueMovimentacao: false,
      indexEdicaoEstoque: 0,
      exibirEditarEstoqueImagem: false,
      exibirFornecedores: false,
      exibirCustos: false,
      exibirContas: false,
      exibirGrupos: false,
      exibirSubGrupos: false,
      exibirCategoriasEstoque: false,
      variacoes: [],
      tipos: [],
      exibirTiposEstoque: false,
      aliquotas: [],
      exibirCamposBasePIS: false,
      exibirCamposBaseCOFINS: false,
      exibirST: false,
      exibirCSOSN: false,
      exibirIbpts: false,
      exibirTributacoes: false,
      exibirGeneroSpeds: false,
      exibirServicosCnaeDets: false,
      exibirTabelaEstados: false,
      exibirCests: false,
      exibirCfops: false,
      exibirAliquotas: false,
      exibirAdicionais: false,
      loadingConfirmar: false,
      isLoading: false,
      errosGerais: {},
      errosValidacao: [],
      errosValidacaoGeral: [],
      add: true,
      produto: JSON.parse(JSON.stringify(produtoInicializado)),
      diasPromocao: [
        {
          dia: "0",
          descricao: "Domingo",
          selecionado: false,
        },
        {
          dia: "1",
          descricao: "Segunda",
          selecionado: false,
        },
        {
          dia: "2",
          descricao: "Terça",
          selecionado: false,
        },
        {
          dia: "3",
          descricao: "Quarta",
          selecionado: false,
        },
        {
          dia: "4",
          descricao: "Quinta",
          selecionado: false,
        },
        {
          dia: "5",
          descricao: "Sexta",
          selecionado: false,
        },
        {
          dia: "6",
          descricao: "Sábado",
          selecionado: false,
        },
      ],
      qtdPessoas: [
        {
          title: "Não se aplica",
          value: "0",
          default: true,
          custom: true,
        },
        {
          title: "1 pessoa",
          value: "1",
          default: false,
          custom: true,
        },
        {
          title: "2 pessoas",
          value: "2",
          default: false,
          custom: true,
        },
        {
          title: "3 pessoas",
          value: "3",
          default: false,
          custom: true,
        },
        {
          title: "4 pessoas",
          value: "4",
          default: false,
          custom: true,
        },
      ],
      money: {
        decimal: ",",
        thousands: ".",
        prefix: "",
        suffix: "",
        length: 11,
        precision: 2,
      },
      options: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 2,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      options2: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: 4,
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: false,
        autoDecimalDigits: true,
        autoSign: true,
        useGrouping: true,
        accountingSign: true,
      },
      optionsPreco: {
        locale: "pt-BR",
        currency: "BRL",
        currencyDisplay: "hidden",
        precision: {
          min: 2,
          max: 10,
        },
        hideCurrencySymbolOnFocus: false,
        hideGroupingSeparatorOnFocus: false,
        hideNegligibleDecimalDigitsOnFocus: true,
      },
      adicionalSelecionado: {
        id: null,
        descricao: "",
      },
      dialogImageUrl: "",
      dialogVisible: false,
      scrollRef: "",
    };
  },
};
</script>

<style>
.imagePreviewWrapper {
  background-size: contain !important;
  background-position: center !important;
}
.image-block {
  width: 100%;
  height: 100%;
  max-height: 500px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.image-block .el-image {
  display: inline-block;
  min-height: 200px;
  max-height: 500px;
}
</style>
